/* ============================================================
   DSS custom scripts — the ONLY script file for DSS customisations.
   Loaded deferred from the DSS HOOK block in layout/theme.liquid.
   No jQuery here: write vanilla JS. See THEME-CHANGES.md.
   ============================================================ */

/* ============================================================
   VAT HELPER (13 Oct 2026, ex-VAT switch — _project/multistore/
   exvat-switch/). The ONE place custom.js turns a stored price into
   an Ex or Inc VAT figure. custom-tokens.liquid prints
   window.DSS_VAT = {basis, includes, rate, appFollow} in <head>,
   resolved by custom-vat-pence.liquid (theme setting dss_vat_basis;
   auto = Shopify's "Include tax in prices"), so Liquid and JS agree.
     DSS_VAT.ex(p, taxable, factor)  → ex-VAT figure of stored p
     DSS_VAT.inc(p, taxable, factor) → inc-VAT figure of stored p
   taxable === false (zero-rated) → p unchanged. Unrounded: callers
   round as they always did. `factor` (optional) overrides 1 + rate/100
   — the cart/quick-view mirrors pass the ratio the Dual Price app
   itself applied. Missing tokens (cached page) → today's behaviour:
   stored prices include 20 % VAT.
   ============================================================ */
(function () {
  var V = window.DSS_VAT || {};
  if (typeof V.includes !== 'boolean') V.includes = true;
  if (!(V.rate >= 0)) V.rate = 20;
  V.factor = 1 + V.rate / 100;
  V.ex = function (p, taxable, factor) {
    return (taxable === false || !V.includes) ? p : p / (factor || V.factor);
  };
  V.inc = function (p, taxable, factor) {
    return (taxable === false || V.includes) ? p : p * (factor || V.factor);
  };
  window.DSS_VAT = V;
  /* Optional backstop (theme setting dss_vat_app_follow, default OFF): make
     the Dual Price app's own tax mode follow the theme. Its config is inline
     `var`s in <head> (dp_base_price_type: '0' = stored prices include tax,
     '1' = exclude); this file is deferred, so it runs after those vars and
     before the app's deferred dualPrice_v5_pro.js reads them. Not a
     substitute for changing the app's admin setting at the flip. */
  if (V.appFollow && typeof window.dp_base_price_type !== 'undefined') {
    window.dp_base_price_type = V.includes ? '0' : '1';
    V.appForced = window.dp_base_price_type;
  }
})();

/* ============================================================
   QUICK VIEW GALLERY: thumbnails swap the main image (26 Aug, Sam —
   clicking a modal thumbnail navigated to the raw zoom JPG on search,
   collection and trending quick views alike). The modal's product
   section never gets its photo slider initialised (no Flickity, no
   thumb bindings), so the vanilla <a href="…zoom.jpg"> just navigates.
   Slides are stacked .product-main-slide divs shown/hidden by the
   starting-slide/secondary-slide classes, keyed by data-media-id that
   matches each thumb's data-id — swap the classes, no lightbox needed
   (Sam: changing the main image is enough). Real PDP thumbs are
   outside .modal--quick-shop and untouched.
   26 Aug late (Sam: "changing variants on the You may also like quick
   view doesn't change the image"): same disease, second symptom — on a
   variant change theme.Product fires variantImageChange and
   updateVariantImage answers it with flickity.goToSlide, so with no
   slider in the modal it returns without moving anything. Catch the
   event (capture phase — it doesn't bubble) when its target sits in a
   quick-shop modal and run the same inline swap keyed by the variant's
   featured_media id. Applies to every quick view (recs, search,
   collections, trending) — the real PDP has a live slider and never
   reaches the fallback.
   ============================================================ */
(function () {
  function swapTo(modal, id) {
    var photos = modal.querySelector('.product__main-photos');
    if (!photos) return;
    photos.querySelectorAll('.product-main-slide').forEach(function (sl) {
      var on = sl.getAttribute('data-media-id') === id;
      sl.classList.toggle('starting-slide', on);
      sl.classList.toggle('secondary-slide', !on);
      /* inline display: the theme hides ALL slides (.product-main-slide{display:none})
         and shows only the literal :first-child — classes alone can't switch that */
      sl.style.display = on ? 'block' : 'none';
    });
    modal.querySelectorAll('a.product__thumb').forEach(function (a) {
      a.classList.toggle('is-active', a.getAttribute('data-id') === id);
    });
  }
  function modalSlider(modal) {   /* future-proof: if the slider ever does init in the modal, defer to it */
    var flEl = modal.querySelector('.product__main-photos .flickity-enabled');
    return flEl && window.Flickity ? window.Flickity.data(flEl) : null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.modal--quick-shop a.product__thumb');
    if (!t) return;
    e.preventDefault();
    var modal = t.closest('.modal--quick-shop');
    var inst = modalSlider(modal);
    if (inst) { inst.select(parseInt(t.getAttribute('data-index'), 10) || 0); return; }
    swapTo(modal, t.getAttribute('data-id'));
  }, true);
  document.addEventListener('variantImageChange', function (e) {
    var modal = e.target && e.target.closest ? e.target.closest('.modal--quick-shop') : null;
    if (!modal || modalSlider(modal)) return;
    var variant = e.detail && e.detail.variant;
    if (!variant || !variant.featured_media) return;
    swapTo(modal, String(variant.featured_media.id));
  }, true);
})();

/* Recently-viewed thumbnails: eager once injected (26 Aug pm, Sam: they
   sometimes load very late or never — lazy discovery is unreliable for
   client-injected content; 8 small thumbs are trivial bytes). */
(function () {
  var rv = document.querySelector('[data-section-type="recently-viewed"]');
  if (!rv) return;
  function eager() {
    rv.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
  }
  new MutationObserver(eager).observe(rv, { childList: true, subtree: true });
  eager();
})();

/* Shared tab-jump scroll (26 Aug v2, Sam: jumps overshot into the middle of
   the accordion content, and fresh-refresh star clicks flicked top-and-back).
   Target is the TAB HEADER itself, landed just below whatever is stuck to the
   top (site-header measured live, not guessed), with a correction pass after
   the smooth scroll (sticky pin/unpin and late image loads shift the target
   mid-flight). window.__dssTabJump suppresses the 18 Aug mobile scroll-pin,
   which otherwise holds the page against this very scroll. */
function dssTabJumpScroll(tab, wasOpen) {
  var behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function headerGap() {
    var h = document.querySelector('.site-header');
    if (!h) return 100;
    var cs = getComputedStyle(h), r = h.getBoundingClientRect();
    var stuck = (cs.position === 'fixed' || cs.position === 'sticky') && r.top <= 1 && r.bottom > 0;
    return (stuck ? r.bottom : Math.min(r.height, 140)) + 24;
  }
  setTimeout(function () {
    var y = tab.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - headerGap();
    window.scrollTo({ top: Math.max(0, y), behavior: behavior });
    setTimeout(function () {
      var d = tab.getBoundingClientRect().top - headerGap();
      if (Math.abs(d) > 10) window.scrollTo({ top: (window.scrollY || window.pageYOffset) + d, behavior: 'auto' });
    }, behavior === 'smooth' ? 750 : 150);
  }, wasOpen ? 200 : 700);
}

/* Judge.me star badge -> opens SmartTabs "Reviews" tab (ported from 7.5.2 main-product.liquid) */

(function () {
  document.addEventListener('click', function (e) {
    // Catch clicks on Judge.me star badge area (badge is sometimes not an <a>)
    const badge = e.target.closest('.jdgm-prev-badge, .jdgm-star-rating');
    if (!badge) return;

    // Find the Smart Tabs "Reviews" tab by visible text (tab number changes)
    const reviewsTabTrigger = Array.from(
      document.querySelectorAll('.smart-tabs-navigation-li,[role="tab"]')
    ).find(el => (el.textContent || '').trim().toLowerCase().includes('reviews'));

    if (!reviewsTabTrigger) return; // let default behaviour happen

    // Stop default jump (because the target is hidden until tab opens)
    e.preventDefault();

    // Open the Reviews tab — but ONLY if its panel is closed. Since the
    // tabs became accordion toggles (FOLDER multiple-open, 19 Aug),
    // clicking an already-open header COLLAPSES it — the "stars sometimes
    // don't work" bug (26 Aug): it failed exactly when Reviews was open.
    var panelId = reviewsTabTrigger.getAttribute('aria-controls');
    var panel = panelId && document.getElementById(panelId);
    var isOpen = panel && panel.offsetParent !== null && panel.getBoundingClientRect().height > 0;
    if (!isOpen) { window.__dssTabJump = Date.now(); reviewsTabTrigger.click(); }
    dssTabJumpScroll(reviewsTabTrigger, isOpen);
  }, true); // capture phase helps if something else stops propagation
})();


/* ==========================================================================
   DSS fragment: cart + product features (merge into assets/custom.js)
   Ported from live 7.5.2 (cart-drawer.liquid inline <script>,
   product-template.liquid inline <script>). Vanilla JS, no dependencies.
   ========================================================================== */

/* --------------------------------------------------------------------------
   CART DRAWER — closeCartDrawer + "Continue Shopping" button
   (markup: snippets/custom-cart-drawer-extras.liquid; old inline onclick
   replaced by the delegated listener below)
   -------------------------------------------------------------------------- */

function closeCartDrawer() {
  // Simulate a click on the close button (uses the theme's native handler)
  var closeButton = document.querySelector('.js-drawer-close');
  if (closeButton) {
    closeButton.click();
  }
}
// Kept on window for parity with 7.5.2, where it was a global.
window.closeCartDrawer = closeCartDrawer;

document.addEventListener('click', function (e) {
  if (e.target.closest('.cart__continue-shopping')) {
    closeCartDrawer();
  }
});

/* --------------------------------------------------------------------------
   CART — AJAX fade-out remove via bin icon (.cart__remove-btn)
   (markup: snippets/cart-item.liquid DSS HOOK)
   -------------------------------------------------------------------------- */

document.addEventListener('click', function (e) {
  var removeBtn = e.target.closest('.cart__remove-btn');
  if (!removeBtn) return;

  e.preventDefault();

  var cartItem = removeBtn.closest('.cart__item');
  var itemKey = cartItem ? cartItem.getAttribute('data-key') : null;
  if (!itemKey) return;

  // Fade out the item visually
  if (cartItem) {
    cartItem.style.opacity = '0.4';
    cartItem.style.pointerEvents = 'none';
  }

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: 0 })
  })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      // Trigger Impulse theme's built-in cart update event
      document.dispatchEvent(new CustomEvent('cart:build'));

      // Also the standard cart updated event
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

      // Update the cart count in the header
      var countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
      });

      // Update subtotal
      var subtotalEl = document.querySelector('[data-subtotal]');
      if (subtotalEl) {
        var formatted = (cart.total_price / 100).toFixed(2);
        subtotalEl.innerHTML = '<span class="dualPrice">£' + formatted + '</span>';
      }

      // If cart is now empty, show the empty state
      if (cart.item_count === 0) {
        var cartForm = document.getElementById('CartDrawerForm');
        if (cartForm) cartForm.classList.add('drawer--has-no-items');
      }
    })
    .catch(function () {
      // If AJAX fails, fall back to the normal link behaviour
      window.location.href = removeBtn.getAttribute('href');
    });
});

/* --------------------------------------------------------------------------
   PRODUCT — readiness badges: Finance / Book-a-Demo click-through to
   SmartTabs tab (matched by visible text prefix) + smooth centre-scroll
   (markup: snippets/custom-product-badges.liquid; old inline onclick
   replaced by the delegated listener below, data-dss-tab-prefix holds the
   tab-text prefix to match)
   -------------------------------------------------------------------------- */

document.addEventListener('click', function (e) {
  var badge = e.target.closest('.product-readiness-badges .badge[data-dss-tab-prefix]');
  if (!badge) return;

  var prefix = (badge.getAttribute('data-dss-tab-prefix') || '').toLowerCase();
  if (!prefix) return;

  var allTabs = document.querySelectorAll('.smart-tabs-navigation-li');
  var targetTab = null;
  allTabs.forEach(function (tab) {
    if (tab.textContent.trim().toLowerCase().indexOf(prefix) === 0) {
      targetTab = tab;
    }
  });

  // No matching tab on this product (the metafield is ticked but the tab was never written): the badge used to be a
  // silent dead click. Fall back to the Ask a Question dialog so the press still leads somewhere (board 3, 18 Sep 2026).
  if (!targetTab || !targetTab.getAttribute('aria-controls')) {
    var ask = document.querySelector('.product-section [data-pas-ask]');
    if (ask) ask.click();
    return;
  }

  var targetId = targetTab.getAttribute('aria-controls');
  // accordion-safe (26 Aug): headers are toggles now — clicking an
  // already-open section collapses it, so only click when closed
  var targetPanel = document.getElementById(targetId);
  var targetOpen = targetPanel && targetPanel.offsetParent !== null && targetPanel.getBoundingClientRect().height > 0;
  if (!targetOpen) { window.__dssTabJump = Date.now(); targetTab.click(); }
  dssTabJumpScroll(targetTab, targetOpen);
  // keyboard and screen-reader users must land where the page just took everyone else: focus follows the jump
  if (!targetTab.hasAttribute('tabindex')) targetTab.setAttribute('tabindex', '-1');
  setTimeout(function () { try { targetTab.focus({ preventScroll: true }); } catch (err) {} }, 800);
});

/* --------------------------------------------------------------------------
   PRODUCT — LoyaltyLion points ("Earn X points") + GA4 view_item_trigger
   (markup + JSON data island: snippets/custom-loyaltylion-points.liquid)
   -------------------------------------------------------------------------- */

(function () {
  window.dataLayer = window.dataLayer || [];

  var POINTS_PER_POUND = 5; // keep in sync with LoyaltyLion config

  function pushViewItemGA4(variant, productTitle) {
    if (!variant) return;
    window.dataLayer.push({
      event: 'view_item_trigger',
      ecommerce: {
        items: [{
          item_name: productTitle,
          item_id: variant.sku || variant.id,
          item_variant: variant.title,
          price: variant.price / 100,
          quantity: 1
        }]
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var dataEls = document.querySelectorAll('[data-dss-ll-data]');
    if (!dataEls.length) return;

    dataEls.forEach(function (dataEl) {
      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      var productTitle = data.productTitle;
      var currentVariant = data.currentVariant;

      var productSection = dataEl.closest('.product-section');
      if (!productSection) return;

      var qtyInput = productSection.querySelector('input[name="quantity"]');
      var pointsEl = productSection.querySelector('.js-ll-points');

      function getQuantity() {
        if (!qtyInput) return 1;
        var qty = parseInt(qtyInput.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        return qty;
      }

      function updatePoints() {
        if (!pointsEl || !currentVariant) return;

        // Shopify gives prices in pence. Points accrue on what the customer PAYS (inc VAT), so gross the stored
        // price up through the VAT helper when the store holds ex-VAT prices (22 Oct 2026, d33); zero-rated = as is.
        var V = window.DSS_VAT;
        var incPence = (V && typeof V.inc === 'function') ? V.inc(currentVariant.price, currentVariant.taxable) : currentVariant.price;
        var pricePounds = incPence / 100;
        var qty = getQuantity();

        var rawPoints = pricePounds * POINTS_PER_POUND * qty;

        // Round to nearest whole number
        var displayPoints = Math.round(rawPoints);

        pointsEl.textContent = displayPoints.toLocaleString('en-GB');   // 82,500 not 82500 (board 3); the dialog's readPoints strips non-digits
      }

      function handleQtyChange() {
        updatePoints();
      }

      // Quantity: listen to typing and plus/minus buttons
      if (qtyInput) {
        qtyInput.addEventListener('input', handleQtyChange);
        qtyInput.addEventListener('change', handleQtyChange);

        var qtyButtons = productSection.querySelectorAll('.js-qty__adjust');
        qtyButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            setTimeout(handleQtyChange, 0);
          });
        });
      }

      // Initial GA4 + points
      pushViewItemGA4(currentVariant, productTitle);
      updatePoints();

      // When variant changes
      document.addEventListener('variant:change', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) return;

        currentVariant = variant;
        pushViewItemGA4(currentVariant, productTitle);
        updatePoints();
      });
    });
  });
})();

/* ============================================================
   DSS fragment: header / announcement features (JS)
   (ported from Impulse 7.5.2 live theme -> 9.2.0)
   ============================================================ */

/* ------------------------------------------------------------
   FEATURE 1: Announcement bar social icon tooltips
   (from old sections/announcement.liquid inline <script>;
   appends a .announcement-tooltip div to <body> and shows it on
   mouseenter/focus of .announcement-social-icons links.
   No-ops when .announcement-social-icons is absent.)
   ------------------------------------------------------------ */
(function () {
  function initAnnouncementTooltips() {
    var links = document.querySelectorAll('.announcement-social-icons a');
    if (!links.length) return; // no announcement socials on this page

    // Create tooltip once
    var tip = document.querySelector('.announcement-tooltip');
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'announcement-tooltip';
      document.body.appendChild(tip);
    }

    function position(a) {
      var r = a.getBoundingClientRect();
      var tipRect = tip.getBoundingClientRect();

      // Place below icon, centered
      var x = r.left + (r.width / 2) - (tipRect.width / 2);
      var y = r.bottom + 8;

      // Keep inside viewport
      var padding = 8;
      var clampedX = Math.max(padding, Math.min(x, window.innerWidth - tipRect.width - padding));

      tip.style.left = clampedX + 'px';
      tip.style.top = y + 'px';
    }

    function show(e) {
      var a = e.currentTarget;
      var text = a.getAttribute('data-tooltip') || a.getAttribute('aria-label') || a.getAttribute('title') || '';
      if (!text) return;

      tip.textContent = text;
      tip.classList.add('is-visible');

      position(a);
    }

    function hide() {
      tip.classList.remove('is-visible');
    }

    links.forEach(function (a) {
      a.addEventListener('mouseenter', show);
      a.addEventListener('mouseleave', hide);
      a.addEventListener('focus', show);
      a.addEventListener('blur', hide);
      a.addEventListener('mousemove', function () { position(a); });
    });

    window.addEventListener('scroll', hide, { passive: true });
    window.addEventListener('resize', hide, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementTooltips);
  } else {
    initAnnouncementTooltips();
  }
})();

/* ------------------------------------------------------------
   FEATURE 3: Header Klaviyo account-hub fallback
   (from old sections/header.liquid inline <script>; the header
   icons container carries id="AccountIcons" via DSS HOOK in
   sections/header.liquid. On account-icon click, waits 150ms and
   if the Klaviyo hub veil/drawer did not open, redirects to the
   Shopify account page. Routes hardcoded: /account is stable and
   Shopify redirects logged-out visitors to /account/login itself.)
   ------------------------------------------------------------ */
(function () {
  function initAccountHubFallback() {
    var wrap = document.getElementById('AccountIcons');
    if (!wrap) return;

    var acc = wrap.querySelector(
      'a[href="/account"], a[href="/account/login"], a[href$="/account"], ' +
      'button[aria-controls*="Account"], [data-klaviyo-customer-hub-trigger]'
    );
    if (!acc) return;

    acc.addEventListener('click', function () {
      // Allow Klaviyo Hub a moment to open
      setTimeout(function () {
        var hubOpen = document.querySelector('.kl-hub-modal-veil, .kl-hub-drawer');
        if (hubOpen) return; // Hub opened -> do nothing

        // Hub blocked (e.g. by consent tooling) -> go to Shopify account page
        window.location.href = '/account';
      }, 150);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccountHubFallback);
  } else {
    initAccountHubFallback();
  }
})();

/* --------------------------------------------------------------------------
   STICKY NAV — smart controller (see matching CSS in custom.css).
   Mode from theme settings via window.DSS_STICKY_NAV:
     smart  — header sticks scrolling down; Globo menu slides in on scroll up
     menu   — Globo bar (theme .toolbar) always sticky
     header — header bar only
     both   — header bar AND Globo bar pinned together, always (7 Sep 2026)
     off    — nothing sticky
   Mobile (<=1259px — the drawer band, see custom.css) always uses header
   mode (unless off): the Globo toolbar is not rendered down there, so the
   smart mode's menu reveal would have nothing to reveal.
   -------------------------------------------------------------------------- */
(function () {
  var MODE = window.DSS_STICKY_NAV || 'smart';
  if (MODE === 'off') return;
  var root = document.documentElement;

  function init() {
    var header = document.querySelector('.site-header');
    var toolbar = document.querySelector('.toolbar');
    if (!header) return;

    function spacerFor(el) {
      if (!el) return null;
      var s = document.createElement('div');
      s.className = 'dss-sticky-spacer';
      el.parentNode.insertBefore(s, el.nextSibling);
      return s;
    }
    var hSpacer = spacerFor(header);
    var tSpacer = spacerFor(toolbar);

    var lastY = window.scrollY;
    var upAcc = 0, downAcc = 0; // accumulated travel per direction
    var stickAt = 0;    // scrolling down past this engages the fixed bars
    var unstickAt = 0;  // scrolling up to this releases them (= the point
                        // where fixed and natural positions coincide, so
                        // the swap is invisible — Headroom-style hysteresis)

    function effMode() {
      return window.matchMedia('(max-width: 1259px)').matches ? 'header' : MODE;
    }

    function setEffClass(m) {
      root.classList.remove('dss-eff-smart', 'dss-eff-menu', 'dss-eff-header', 'dss-eff-both');
      root.classList.add('dss-eff-' + m);
    }

    function reset() {
      upAcc = 0; downAcc = 0;
      root.classList.remove('dss-scrolled', 'dss-up');
      if (hSpacer) hSpacer.style.height = '0px';
      if (tSpacer) tSpacer.style.height = '0px';
    }

    // --dss-hh is the fixed toolbar's top offset = live header height.
    // The header height ANIMATES (logo grow, padding), so a one-shot
    // measurement detaches the menu; these keep it glued frame-by-frame.
    function syncHH() {
      root.style.setProperty('--dss-hh', header.offsetHeight + 'px');
    }
    var syncing = false;
    function syncLoop(ms) {
      if (syncing) return;
      syncing = true;
      var end = performance.now() + ms;
      (function step() {
        syncHH();
        if (performance.now() < end) requestAnimationFrame(step);
        else syncing = false;
      })();
    }

    function anchorEl() {
      return (effMode() === 'menu' && toolbar) ? toolbar : header;
    }

    function measure() {
      var wasActive = root.classList.contains('dss-scrolled');
      reset();
      var r = anchorEl().getBoundingClientRect();
      var naturalTop = r.top + window.scrollY;
      // Pin exactly where the bar meets the viewport top: engaging and
      // releasing at the same aligned point means nothing ever jumps,
      // and the nav is never absent mid-scroll.
      unstickAt = naturalTop;
      stickAt = naturalTop;
      root.style.setProperty('--dss-hh', Math.round(header.getBoundingClientRect().height) + 'px');
      if (wasActive) update();
    }

    function update() {
      var m = effMode();
      setEffClass(m);
      var y = window.scrollY;
      var dy = y - lastY;
      lastY = y;
      var scrolled = root.classList.contains('dss-scrolled');

      // Hysteresis: engage only well past the header, release only where
      // the fixed bar lines up with the header's natural position.
      if ((scrolled && y <= unstickAt) || (!scrolled && y <= stickAt)) {
        if (scrolled) reset();
        return;
      }

      if (!scrolled) {
        // reserve the space of whatever leaves the document flow
        if (hSpacer) hSpacer.style.height = (m === 'menu' ? 0 : header.offsetHeight) + 'px';
        if (tSpacer) tSpacer.style.height = (m === 'header' ? 0 : (toolbar ? toolbar.offsetHeight : 0)) + 'px';
        root.classList.add('dss-scrolled');
        root.classList.add('dss-up'); // menu starts visible, slides away on continued down-scroll
        upAcc = 0; downAcc = 0;
        syncLoop(450);
      } else {
        syncHH();
      }

      // Direction reveal on ACCUMULATED travel (slow trackpad scrolls emit
      // many tiny deltas that a per-event threshold would miss). Near the
      // top, keep the full unit visible so the release is always seamless.
      if (dy < 0) { upAcc += -dy; downAcc = 0; }
      else if (dy > 0) { downAcc += dy; upAcc = 0; }
      if (upAcc > 10 || y <= stickAt) root.classList.add('dss-up');
      else if (downAcc > 10) root.classList.remove('dss-up');
    }

    setEffClass(effMode());
    measure();
    header.addEventListener('transitionend', function () {
      if (root.classList.contains('dss-scrolled')) syncLoop(100);
    });
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { measure(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --------------------------------------------------------------------------
   TOOLBAR NAV — one row at every desktop width (priority+ "More" fold).
   Companion CSS: "DSS DESKTOP NAV — ONE ROW" block in custom.css.

   The .toolbar row IS the Globo mega menu. CSS already guarantees the row
   can never wrap (flex-wrap:nowrap) and pins the link box to 50px, so the
   height is constant — this file's job is making the CONTENT fit that row.

   Type metrics are fixed at Globo's own values now (the compression tiers
   were removed 4 Aug — Sam found the squeezed spacing muddled), so folding
   is the only in-row lever and this is a plain priority+ nav: fold 0, 1 or
   2 items, whichever is the fewest that fits. State is re-derived from
   scratch on every pass, so the nav is identical whether you arrived at a
   width by loading or by dragging.

   Only TRAILING PLAIN-LINK items may fold (PLUSH TOYS, REWARDS): items with
   .gm-has-submenu own an absolutely-positioned mega panel and moving them
   breaks Globo's positioning, so the walk stops at the first one it meets.
   Below the drawer boundary the toolbar is not rendered at all.

   CSS hides those same two items from first paint below the fold threshold
   and clips the toolbar until we settle; this code adds .dss-nav-ready when
   it has actually run, which hands both jobs back to the JS state.
   -------------------------------------------------------------------------- */
(function () {
  var MQ = '(min-width: 1260px)';
  var ul = null;      // the live .toolbar__menu
  var more = null;    // our "More" <li>
  var panel = null;   // its dropdown <ul>
  var folded = [];    // [{ li, next }] in fold order; last folded restores first
  var busy = false;
  var closeTimer = null;

  function menuEl() {
    return document.querySelector('.toolbar .toolbar__menu');
  }
  function desktop() {
    return window.matchMedia(MQ).matches;
  }

  /* ---------- measurement ---------- */
  function rowItems() {
    return Array.prototype.filter.call(ul.children, function (li) {
      return li.getBoundingClientRect().width > 0;
    });
  }
  function contentWidth() {
    var w = 0;
    rowItems().forEach(function (li) { w += li.getBoundingClientRect().width; });
    return w;
  }
  function availWidth() {
    // The page-width content box is the honest limit: if the row overflows,
    // the <ul>'s own box can be dragged wider by its flex parent.
    var pw = ul.parentNode && ul.parentNode.closest ? ul.parentNode.closest('.page-width') : null;
    var a = ul.clientWidth;
    if (pw) {
      var cs = window.getComputedStyle(pw);
      var inner = pw.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (inner > 0) a = Math.min(a || inner, inner);
    }
    return a;
  }
  function fits() {
    return contentWidth() <= availWidth() - 1;
  }

  /* ---------- the More item ---------- */
  function ensureMore() {
    if (more && more.parentNode === ul) return;
    more = document.createElement('li');
    more.className = 'gm-item gm-level-0 gm-has-submenu dss-more';
    var a = document.createElement('a');
    a.className = 'gm-target dss-more__toggle';
    a.setAttribute('href', '#');
    a.setAttribute('role', 'button');
    a.setAttribute('aria-haspopup', 'true');
    a.setAttribute('aria-expanded', 'false');
    a.setAttribute('aria-label', 'More menu items');
    var text = document.createElement('span');
    text.className = 'gm-text';
    text.textContent = 'MORE';
    a.appendChild(text);
    // clone a real chevron so it matches the row exactly
    var chev = ul.querySelector('.gm-retractor');
    if (chev) {
      a.appendChild(chev.cloneNode(true));
    } else {
      var fake = document.createElement('span');
      fake.className = 'gm-retractor';
      a.appendChild(fake);
    }
    panel = document.createElement('ul');
    panel.className = 'dss-more__panel';
    more.appendChild(a);
    more.appendChild(panel);
    ul.appendChild(more);
    bindMore(a);
  }
  function removeMore() {
    if (!more) return;
    if (panel && panel.children.length) return;
    if (more.parentNode) more.parentNode.removeChild(more);
    more = null;
    panel = null;
  }
  function openMore() {
    if (!more) return;
    more.classList.add('dss-more--open');
    var t = more.querySelector('.dss-more__toggle');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeMore() {
    if (!more) return;
    more.classList.remove('dss-more--open');
    var t = more.querySelector('.dss-more__toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  function bindMore(a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      if (more.classList.contains('dss-more--open')) closeMore(); else openMore();
    });
    more.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (window.matchMedia('(hover: hover)').matches) openMore();
    });
    more.addEventListener('mouseleave', function () {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMore, 180);
    });
  }
  document.addEventListener('click', function (e) {
    if (more && !more.contains(e.target)) closeMore();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeMore();
  });

  /* ---------- fold / restore ---------- */
  function nextFoldable() {
    var items = rowItems().filter(function (li) { return li !== more; });
    var last = items[items.length - 1];
    if (!last) return null;
    if (last.classList.contains('gm-has-submenu')) return null; // mega panel: never move
    return last;
  }
  function fold(li) {
    ensureMore();
    folded.push({ li: li, next: li.nextSibling });
    panel.insertBefore(li, panel.firstChild); // keeps document order in the panel
  }
  function restoreLast() {
    var f = folded.pop();
    if (!f) return;
    var ref = (f.next && f.next.parentNode === ul) ? f.next : more;
    ul.insertBefore(f.li, ref || null);
  }
  function setFolds(n) {
    while (folded.length > n) restoreLast();
    while (folded.length < n) {
      var li = nextFoldable();
      if (!li) break;
      fold(li);
    }
    if (!folded.length) removeMore();
    return folded.length;
  }
  function markReady() {
    var tb = document.querySelector('.toolbar');
    if (tb) tb.classList.add('dss-nav-ready');
  }

  /* ---------- the decision ---------- */
  function recompute() {
    var el = menuEl();
    if (!el) return;
    if (el !== ul) { ul = el; more = null; panel = null; folded = []; }
    // Globo rebuilds the list from scratch; if it did, our nodes went with it
    if (more && more.parentNode !== ul) { more = null; panel = null; folded = []; }
    if (panel) {
      folded = folded.filter(function (f) { return f.li.parentNode === panel; });
    }
    if (busy) return;
    busy = true;
    try {
      // Below the drawer boundary the drawer owns the navigation and the
      // toolbar is display:none — hand everything back so the row is
      // pristine if the window is dragged wide again.
      if (!desktop()) {
        setFolds(0);
        removeMore();
        markReady();
        return;
      }
      // Before Globo initialises the row holds the theme's placeholder links,
      // which Globo is about to throw away — never fold those, and stay
      // un-ready so the CSS keeps the row clipped.
      if (!ul.classList.contains('gm-menu')) return;

      // Ready FIRST, then measure. The pre-paint CSS hides the two foldable
      // items, and a hidden item measures 0 and reads as "not there" — which
      // made the search conclude the row already fitted, mark ready, and let
      // the pair pop back in (a real 56px horizontal overflow, caught by the
      // load probe). Releasing the hide before measuring puts both mechanisms
      // in the same frame: everything from here down is synchronous, so the
      // browser cannot paint the un-folded row in between.
      markReady();

      for (var n = 0; n <= 2; n++) {
        var got = setFolds(n);
        if (fits()) break;
        if (got < n) break; // nothing left that may be folded
      }
      // Fewest folds that fit; at the drawer boundary two folds is always
      // enough (measured), and below it the toolbar is not shown.
    } finally {
      busy = false;
      lastRun = Date.now();
    }
  }

  /* ---------- scheduling ---------- */
  var t = null;
  var lastRun = 0;
  function schedule(delay) {
    clearTimeout(t);
    t = setTimeout(recompute, delay || 150);
  }

  function start() {
    if (!menuEl()) return;
    // per-store switch (Theme settings → DSS Layout → Store features → nav pre-paint OFF):
    // no fold/MORE, no watchdog state — just release the pre-paint hides/clip and stand down
    if (document.documentElement.classList.contains('dss-nav-plain')) { markReady(); return; }
    recompute();
    // Globo's bundle lands after us; catch its rebuild
    [300, 800, 1500, 2500, 4000].forEach(function (ms) { setTimeout(recompute, ms); });
    window.addEventListener('resize', function () { schedule(150); }, { passive: true });
    window.addEventListener('orientationchange', function () { schedule(250); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { schedule(50); });
    }
    var target = menuEl().parentNode;
    if (window.MutationObserver && target) {
      new MutationObserver(function () {
        // ignore the churn our own search creates; only react to Globo's
        if (busy || Date.now() - lastRun < 600) return;
        schedule(200);
      }).observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   CART — minimum-order progress bar (snippet custom-cart-minimum-bar).
   Same events as the shipping bar; the ex-VAT position is DSS_VAT.ex(total)
   (13 Oct 2026: the one VAT helper — inc storage takes the VAT off, ex
   storage uses the total as is; the old data-divisor / tax-exempt branch
   is gone, trade accounts are keyed on the NOVAT tag everywhere else).
   ============================================================ */
(function () {
  var bar = document.querySelector('[data-dss-min-bar]');
  if (!bar) return;
  var minEx = parseInt(bar.getAttribute('data-threshold'), 10);
  if (!minEx) return;
  var msgEl = bar.querySelector('[data-dss-min-message]');
  var fillEl = bar.querySelector('[data-dss-min-fill]');
  var subEl = bar.querySelector('[data-dss-min-sub]');
  function money(c) { return '\u00a3' + (c / 100).toFixed(2); }
  function render(total) {
    var ex = Math.round(window.DSS_VAT.ex(total));
    var pct = Math.min(100, Math.round((ex / minEx) * 100));
    fillEl.style.width = pct + '%';
    if (ex >= minEx) {
      bar.classList.add('dss-min-bar--reached');
      msgEl.innerHTML = '<strong>Minimum order reached</strong>';
    } else {
      bar.classList.remove('dss-min-bar--reached');
      msgEl.innerHTML = 'Add <strong>' + money(minEx - ex) + '</strong> to reach the minimum order';
    }
    if (subEl) subEl.textContent = 'Basket ' + money(ex) + ' ex VAT';
  }
  function refresh() {
    var x = new XMLHttpRequest();
    x.open('GET', '/cart.js'); x.onload = function () { try { render(JSON.parse(x.responseText).total_price); } catch (e) {} }; x.send();
  }
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart && typeof evt.detail.cart.total_price === 'number') render(evt.detail.cart.total_price); else refresh();
  });
  document.addEventListener('cart:build', refresh);
  document.addEventListener('ajaxProduct:added', refresh);
})();

/* ============================================================
   CART — free-shipping progress bar (snippet custom-cart-shipping-bar,
   hooked into cart-drawer.liquid). Liquid renders the initial state;
   this keeps it in sync on cart changes (theme + our AJAX remove both
   dispatch cart:updated with detail.cart; cart:build has no payload so
   we re-fetch /cart.js).
   ============================================================ */
(function () {
  var bar = document.querySelector('[data-dss-shipping-bar]');
  if (!bar) return;

  var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
  if (!threshold || threshold <= 0) return;

  var msgEl = bar.querySelector('[data-dss-shipping-message]');
  var fillEl = bar.querySelector('[data-dss-shipping-fill]');

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function render(totalCents) {
    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
    fillEl.style.width = pct + '%';
    if (totalCents >= threshold) {
      bar.classList.add('dss-shipping-bar--unlocked');
      msgEl.textContent = 'You’ve unlocked FREE delivery 🎉';
    } else {
      bar.classList.remove('dss-shipping-bar--unlocked');
      msgEl.textContent = 'Spend ' + formatMoney(threshold - totalCents) + ' more for FREE delivery';
    }
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price); })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart && typeof evt.detail.cart.total_price === 'number') {
      render(evt.detail.cart.total_price);
    } else {
      refresh();
    }
  });
  document.addEventListener('cart:build', refresh);
  document.addEventListener('ajaxProduct:added', refresh);  /* add path fires neither event above */
})();

/* ============================================================
   HEADER — cart count badge + price pill (markup in
   snippets/header-icons.liquid via DSS HOOK). Liquid renders the
   initial state; this keeps both live on the same cart events as
   the shipping bar above.
   ============================================================ */
(function () {
  var countEl = document.querySelector('[data-dss-cart-count]');
  var priceEl = document.querySelector('[data-dss-cart-price]');
  if (!countEl || !priceEl) return;

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function render(cart) {
    countEl.textContent = cart.item_count;
    priceEl.textContent = formatMoney(cart.total_price);
    countEl.classList.toggle('is-empty', cart.item_count === 0);
    priceEl.classList.toggle('is-empty', cart.item_count === 0);
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart && typeof evt.detail.cart.item_count === 'number') {
      render(evt.detail.cart);
    } else {
      refresh();
    }
  });
  document.addEventListener('cart:build', refresh);
  /* The ADD path never dispatches cart:updated/cart:build — the theme
     only updates its own .cart-link__bubble-num there (which our badge
     replaced). ajaxProduct:added fires on every add: PDP, quick view,
     sticky bar (fix 14 Aug: badge froze until refresh). */
  document.addEventListener('ajaxProduct:added', refresh);
})();

/* ============================================================
   PRODUCT — per-unit pack savings under the price (snippet
   custom-pack-savings, hooked into product-template.liquid).
   Variant titles "Pack of 5" / "Box of 25" / "5 Pack" → per-unit
   price + % saving vs the "Single"/qty-1 variant (if one exists).
   Updates on the theme's variant:change event.
   ============================================================ */
(function () {
  /* Returns {qty, explicit} — explicit means the title says "pack"/"box"
     in words. A bare numeric option value ("Black / 20") only counts when
     the product also has a qty-1 variant, checked by the caller. */
  function packQty(title) {
    if (!title) return null;
    var t = title.trim();
    if (/(^|\/\s*)single\b/i.test(t)) return { qty: 1, explicit: true };
    var m = t.match(/(?:pack|box|bundle|set|pallet|case)\s+of\s+(\d+)/i) || t.match(/(?:^|\/\s*)(\d+)\s*(?:pack|pk|pcs|pieces)\b/i);
    if (m) return { qty: parseInt(m[1], 10), explicit: true };
    /* 13 Oct 2026 (Sam: the Halloween Mystery Box showed "£1.67 per unit — save 80% vs single"): a bare number is
       only a pack quantity when no other part of the title is a size or an age — "5/6 years" and "1/2 years" are
       children's sizes, not packs of 5 and 1. */
    if (/\b(years?|months?|yrs?|cm|mm|ml|oz|inch|inches|litre|liter)\b|["″]/i.test(t)) return null;
    var numeric = null;
    t.split('/').forEach(function (part) {
      if (/^\d+$/.test(part.trim())) numeric = parseInt(part.trim(), 10);
    });
    return numeric !== null ? { qty: numeric, explicit: false } : null;
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dss-pack-data]').forEach(function (dataEl) {
      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      var out = dataEl.parentElement && dataEl.parentElement.querySelector('[data-dss-pack-savings]');
      var scope = dataEl.closest('.product-section');
      if (!out && scope) out = scope.querySelector('[data-dss-pack-savings]');
      if (!out || !data.variants || !data.variants.length) return;

      var baseline = null;
      data.variants.forEach(function (v) {
        var p = packQty(v.title);
        if (p && p.qty === 1 && (baseline === null || v.price < baseline)) {
          baseline = v.price;
        }
      });

      function render(variantId) {
        var variant = data.variants.filter(function (v) { return v.id === variantId; })[0];
        var pack = variant && packQty(variant.title);
        var qty = pack && pack.qty;
        if (!variant || !qty || qty <= 1 || (!pack.explicit && baseline === null)) {
          out.dataset.dssOwn = 'hide';
          out.hidden = true;
          return;
        }
        /* Show the Ex VAT per-unit so this line matches the price block's
           bold Ex VAT figure. The Ex figure comes from DSS_VAT.ex (the one VAT
           helper: follows dss_vat_basis — inc storage takes VAT off, ex storage
           is as stored). The % saving is a ratio, so it's identical whether
           computed ex or inc VAT. */
        /* Zero-rated products (variant.taxable === false, e.g. children's
           clothing) have NO VAT in the stored price — dividing fabricates
           a discount that doesn't exist. DSS_VAT.ex returns them as stored,
           and no "Ex VAT" label for those (no ex/inc distinction to draw). */
        var perUnit = variant.price / qty;                                  // stored per unit (ratio only)
        var perUnitEx = window.DSS_VAT.ex(variant.price, variant.taxable) / qty;   // ex-VAT per unit (displayed)
        var text = formatMoney(perUnitEx) + (variant.taxable === false ? ' per unit' : ' per unit Ex VAT');
        if (baseline && baseline > 0 && perUnit < baseline) {
          var pct = Math.round((1 - perUnit / baseline) * 100);
          if (pct >= 1) text += ' — save ' + pct + '% vs single';
        }
        out.textContent = text;
        /* WSS, 10 Sep 2026 (launch sweep S3): when the metafield-driven
           unit-price panel (custom-unit-price) is showing for this variant it
           already says "Each, ex VAT £10.64", so this title-derived line would
           state the same figure twice — and from a different source. The panel
           wins whenever it is visible; its own render re-syncs this line via
           data-dss-own, so both orders of DOMContentLoaded / variant:change end
           up right. */
        out.dataset.dssOwn = 'show';
        var dssPanel = (scope || dataEl.parentElement).querySelector('[data-wss-unit-price]');
        out.hidden = !!(dssPanel && !dssPanel.hidden);
      }

      render(data.currentVariantId);

      document.addEventListener('variant:change', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) return;
        if (scope && event.target && event.target.closest && event.target.closest('.product-section') && event.target.closest('.product-section') !== scope) return;
        render(variant.id);
      });
    });
  });
})();

/* ============================================================
   DUAL PRICE APP — keep EVERY cart-drawer line dual-priced.

   All "£X Ex VAT / £Y Inc VAT" output belongs to the Dual Price
   Display PRO app: the shop money format server-renders every price
   as <span class="dualPrice">£5.03</span>, and the app's JS rewrites
   that span into .secondPrice (Ex VAT) + .firstPrice (Inc VAT) per
   its own customer-tag / market rules (NOVAT trade accounts are
   deliberately shown a single Ex VAT line). A span the app has not
   touched shows the raw price, which in this store is the INC VAT
   figure, with no label — misleading. We never compute or label
   prices here; we only make the app run again until it has finished.

   Two app behaviours leave drawer lines bare:

     1. Its scan collects every `a[href*="products/"]` on the page but
        SKIPS `productDPHandle` — the product whose PDP you are on.
        A drawer line for that product is therefore never decorated
        by the app's own passes (initial load and its 3s retry). This
        is why one line renders as a bare "£5.03". Live site too.
     2. The theme swaps in freshly rendered drawer HTML asynchronously
        AFTER `cart:updated` fires, so a single debounced pass can
        decorate markup that is then thrown away — the +/- and remove
        steppers hit this intermittently.

   So: watch the drawer, and after it settles keep re-running the
   app's own runDisplayDualPrice (with productDPHandle temporarily
   cleared) until no line is left bare. Capped at MAX_PASSES, and
   lines the app still refuses to decorate are marked so they can
   never keep the loop alive. Re-running is safe: the app's own
   getPricePath ignores spans it has already marked `.dp_catalog`,
   so lines are never decorated twice.

   THIRD, AND WHY EVERY LINE IS VERIFIED: the app decorates a cart
   line from the PRODUCT's JSON (`/products/<handle>.js` → `price`,
   i.e. the FIRST/cheapest variant), not from the line's own variant.
   A "Box of 50" line whose real price is £232.55 is therefore
   rewritten to the single-unit "£4.19 Ex VAT / £5.03 Inc VAT" — a
   wrong price stated with confidence, which is far worse than a
   missing label. This is the app's own behaviour: it happens with no
   DSS code involved at all (reproduced on the home page, where
   productDPHandle is undefined and nothing of ours runs), so it is
   on the live site too and is not something the theme can fix
   properly — only detect. Every decorated line is therefore checked
   against `data-dss-unit-price` (the true per-unit price in pence,
   from snippets/cart-item.liquid) and any line the app got wrong is
   put back to its server-rendered price. We never compute or label a
   price here — a reverted line simply shows what Liquid rendered.
   ============================================================ */
(function () {
  /* 14 Oct 2026: with the native Ex/Inc display on (dss_dual_native, assets/custom-dual-price.js)
     there is no app to re-run, police or mirror — that module renders the drawer lines from
     data-dss-unit-price and the quick view from the variant JSON. Everything below is the
     app-era babysitter and stands down. */
  if (window.DSS_DUAL && window.DSS_DUAL.native) return;
  /* Cart LINE prices only. The drawer/header subtotals are not
     product prices so the app can never decorate them, and on /cart
     the app sets `isCart` and deliberately does nothing at all —
     including either would give the retry loop work it can't finish. */
  var LINE_SEL = '#CartDrawer [data-key] .dualPrice';
  var QUIET_MS = 250;    /* let the theme's drawer rebuild stop churning */
  var SETTLE_MS = 1600;  /* one app pass ≈ 1200 ms (a product JSON fetch each) */
  var MAX_PASSES = 4;    /* hard cap while lines stay bare */
  var LOAD_MS = 1500;    /* first check: after the app's own load pass */
  var DONE_ATTR = 'data-dss-dp-gave-up';
  var RAW_ATTR = 'data-dss-dp-raw';

  var quietTimer = null, settleTimer = null, passes = 0, lastPass = 0;

  /* Line prices the app has not decorated and has not given up on. */
  function bare() {
    var out = [];
    document.querySelectorAll(LINE_SEL).forEach(function (el) {
      if (el.hasAttribute(DONE_ATTR)) return;
      if (el.querySelector('.firstPrice, .secondPrice')) return;
      out.push(el);
    });
    return out;
  }

  /* "£232.55" -> 23255. Currency symbol, spaces and thousands
     separators dropped; the last group after '.' or ',' is the pence. */
  function pence(text) {
    var m = String(text).replace(/[^\d.,]/g, '').match(/(\d[\d.,]*)/);
    if (!m) return null;
    var digits = m[1].replace(/[.,](?=\d{3}\b)/g, '').replace(',', '.');
    var n = Math.round(parseFloat(digits) * 100);
    return isNaN(n) ? null : n;
  }

  /* The app renders both a tax-incl and a tax-excl figure from one
     base price, so for a correctly decorated line ONE of the two must
     still equal the line's real price. If neither does, the app has
     substituted another variant's price — undo it. Keeping the
     .dp_catalog class is what stops the app decorating it again
     (its getPricePath skips spans carrying that class). */
  function verify() {
    document.querySelectorAll(LINE_SEL).forEach(function (el) {
      var host = el.closest('[data-dss-unit-price]');
      var shown = el.querySelectorAll('.firstPriceValue, .secondPriceValue');
      if (!host || !shown.length) return;             /* nothing to check against */
      /* NOVAT trade logins: the app deliberately renders a SINGLE Ex VAT
         line, which on an inc-VAT store can never equal data-dss-unit-price
         (the stored inc figure) — without this guard verify() would revert the app's
         intentional display on every NOVAT line. One price line = the
         app meant it; leave it alone. (Audit finding, 4 Aug.) */
      if (el.querySelector('.secondPriceValue') && !el.querySelector('.firstPriceValue')) return;
      var truth = parseInt(host.getAttribute('data-dss-unit-price'), 10);
      if (isNaN(truth)) return;
      /* Zero-rated lines: the app's FIRST pass correctly refuses these
         (tags the span .nonTaxableVariant and returns) but a later pass
         can decorate them anyway with its fixed-20% maths — fabricating
         an Ex VAT figure for a product that has no VAT (baby grow £5.40
         rendered as "£4.50 Ex VAT / £5.40 Inc VAT", 14 Aug). The Inc
         figure matches the real price, so the one-of-two check below
         would wave it through — but a dual display on a non-taxable
         line is wrong BY DEFINITION. Restore the server-rendered single
         price, even if we previously marked the line done. */
      if (el.classList.contains('nonTaxableVariant')) {
        var rawNT = el.getAttribute(RAW_ATTR);
        if (rawNT == null) {
          try { rawNT = window.Shopify.formatMoney(truth, window.dp_money_format); }
          catch (e) { return; }
        }
        el.textContent = rawNT;
        el.classList.add('dp_catalog');
        el.setAttribute(DONE_ATTR, 'non-taxable');
        return;
      }
      var ok = false;
      shown.forEach(function (v) { if (pence(v.textContent) === truth) ok = true; });
      if (ok || el.hasAttribute(DONE_ATTR)) return;
      var raw = el.getAttribute(RAW_ATTR);
      if (raw == null) {
        /* Snapshot missed (we arrived after the app). Re-render from the
           shop's own money format rather than inventing one. */
        try { raw = window.Shopify.formatMoney(truth, window.dp_money_format); }
        catch (e) { return; }  /* can't restore safely — leave the app's output */
      }
      el.textContent = raw;
      el.classList.add('dp_catalog');
      el.setAttribute(DONE_ATTR, 'wrong-variant');
    });
  }

  /* Keep the server-rendered money string of every line price, taken
     before the app rewrites it, so a wrong line can be put back
     byte-for-byte. Runs on every drawer change, ahead of the app. */
  function snapshot() {
    document.querySelectorAll(LINE_SEL).forEach(function (el) {
      if (el.hasAttribute(RAW_ATTR)) return;
      if (el.querySelector('.firstPrice, .secondPrice')) return;  /* already rewritten */
      el.setAttribute(RAW_ATTR, el.textContent.trim());
    });
  }

  /* Every app pass opens with jQuery('.dualPrice').hide() and only
     re-shows once its product fetches resolve. Two overlapping passes
     clobber the app's globals and the re-show can be skipped, leaving
     prices invisible. Undo that — visibility only, never values. */
  function unhideStuck() {
    document.querySelectorAll(LINE_SEL).forEach(function (el) {
      if (el.style.display === 'none') el.style.removeProperty('display');
    });
  }

  function runPass() {
    if (typeof window.runDisplayDualPrice !== 'function' || !window.jQuery) return false;
    try {
      /* Clear productDPHandle so the current PDP's product is included
         in the scan (root cause 1). The scan is synchronous, so restore
         it straight after; leaving it undefined also makes the app skip
         its renderProductDetail step, so the PDP price block is
         untouched — which is what we want, it is already correct. */
      var hadPdh = typeof window.productDPHandle !== 'undefined';
      var pdh = hadPdh ? window.productDPHandle : null;
      if (hadPdh) window.productDPHandle = undefined;
      try {
        window.runDisplayDualPrice([window.jQuery]);
      } finally {
        if (hadPdh) window.productDPHandle = pdh;
      }
    } catch (err) {
      return false; /* app internals changed — never break the cart */
    }
    return true;
  }

  /* LAST RESORT — the app simply refuses some lines (verified: even a
     manual runDisplayDualPrice leaves them bare, e.g. a Box-of-50 pack
     variant), which left a raw "£232.55" sitting next to properly
     decorated siblings. That bare figure is the STORED price with no
     label (inc VAT on an inc store, ex VAT once the store stores ex), which
     reads differently from an identical decorated one.
     We do NOT invent a pricing rule: we copy what the app itself did to
     a sibling line in the same drawer — same VAT ratio, same labels,
     same classes. If NO sibling is decorated (e.g. a NOVAT trade login,
     where the app deliberately shows a single Ex VAT line) we do
     nothing, so those customers can never be shown an Inc VAT line. */
  /* Find something the app decorated to copy from. Three tiers, most
     specific first — all three REQUIRE the app to have produced dual
     markup for THIS session, which is what keeps NOVAT trade logins
     safe (their pages carry no dual pattern anywhere):
       1. another line in the drawer;
       2. any decorated price on the page (PDP price, product cards) —
          covers a single-line cart of a refused variant, where the
          drawer itself has nothing to copy (Sam's 15oz-mug case);
       3. the app's own template + config globals (dualPriceBlock,
          dp_tax_percent, dp_tax_*_label) — its exact labels and rate,
          used only when the template itself contains both price lines. */
  function mirrorModel() {
    var m = document.querySelector(LINE_SEL + ' .secondPriceValue') ||
            document.querySelector('.dualPrice .secondPriceValue');
    if (m) {
      var wrap = m.closest('.dualPrice');
      var exEl = wrap.querySelector('.secondPriceValue');
      var incEl = wrap.querySelector('.firstPriceValue');
      var exLab = wrap.querySelector('.secondPriceLabel');
      var incLab = wrap.querySelector('.firstPriceLabel');
      if (exEl && incEl && exLab && incLab) {
        var exN = parseFloat(exEl.textContent.replace(/[^\d.]/g, ''));
        var incN = parseFloat(incEl.textContent.replace(/[^\d.]/g, ''));
        if (exN && incN && incN > exN) {
          return { ratio: Math.round((incN / exN) * 100) / 100,
                   exLabel: exLab.textContent, incLabel: incLab.textContent };
        }
      }
    }
    if (typeof window.dualPriceBlock === 'string' &&
        /firstPrice/.test(window.dualPriceBlock) && /secondPrice/.test(window.dualPriceBlock) &&
        window.dp_tax_percent && window.dp_tax_excl_label && window.dp_tax_incl_label) {
      var pct = parseFloat(window.dp_tax_percent);
      if (pct > 0) return { ratio: Math.round((1 + pct / 100) * 100) / 100,
                            exLabel: window.dp_tax_excl_label, incLabel: window.dp_tax_incl_label };
    }
    return null;
  }

  function mirrorSibling(nodes) {
    var model = mirrorModel();
    if (!model) return;                       /* no dual pattern this session — leave alone */
    /* Snap to 2dp: a sibling's figures are already rounded to the penny,
       so a raw ratio off a cheap item (5.03/4.19, a hair over the rate)
       drifts the result by pennies on an expensive line. The snapped
       ratio is what the app actually applies. Still derived from the app, not hardcoded. */
    var ratio = model.ratio;

    nodes.forEach(function (el) {
      if (el.querySelector('.firstPrice, .secondPrice')) return;   /* already fine */
      var stored = null;
      var host = el.closest('[data-dss-unit-price]');
      if (host) stored = parseInt(host.getAttribute('data-dss-unit-price'), 10);
      if (isNaN(stored) || stored === null) return;                /* no trusted figure */
      /* the stored figure is Inc or Ex depending on the store's VAT basis — the
         helper derives the other with the app's own ratio (13 Oct 2026) */
      var exPence = Math.round(window.DSS_VAT.ex(stored, true, ratio));
      var incPence = Math.round(window.DSS_VAT.inc(stored, true, ratio));
      var fmt = function (p) {
        try { return window.Shopify.formatMoney(p, window.dp_money_format); }
        catch (e) { return null; }
      };
      var exTxt = fmt(exPence), incTxt = fmt(incPence);
      if (!exTxt || !incTxt) return;
      el.innerHTML =
        '<span class="secondPrice"><span class="secondPriceValue">' + exTxt + '</span> ' +
        '<span class="secondPriceLabel">' + model.exLabel + '</span></span><br>' +
        '<span class="firstPrice"><span class="firstPriceValue">' + incTxt + '</span> ' +
        '<span class="firstPriceLabel">' + model.incLabel + '</span></span>';
      el.classList.add('dp_catalog');          /* stops the app re-processing it */
      el.setAttribute('data-dss-dp-mirrored', '1');
    });
  }

  /* Lines the retry loop has given up on that are STILL bare. The first
     mirror attempt can happen before the app has decorated anything, so
     there is no sibling to copy yet — we re-attempt on later checks. */
  function gaveUpBare() {
    var out = [];
    document.querySelectorAll(LINE_SEL).forEach(function (el) {
      if (el.hasAttribute(DONE_ATTR) &&
          !el.querySelector('.firstPrice, .secondPrice') &&
          !el.hasAttribute('data-dss-dp-mirrored')) out.push(el);
    });
    return out;
  }

  function giveUp(nodes) {
    mirrorSibling(nodes);
    nodes.forEach(function (el) { el.setAttribute(DONE_ATTR, '1'); });
    unhideStuck();
    passes = 0;
  }

  function schedule(ms) {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () { unhideStuck(); check(); }, ms);
  }

  function check() {
    /* First, police what is already on screen — including decoration
       done by the app's own passes, which we never scheduled. */
    verify();

    /* Re-attempt the sibling mirror for anything we gave up on earlier
       (a sibling may only have become decorated since). */
    var stranded = gaveUpBare();
    if (stranded.length) mirrorSibling(stranded);

    var left = bare();
    if (!left.length) { passes = 0; return; }   /* all correct — idle */

    /* A pass is still in flight: let it land before judging it. */
    var since = Date.now() - lastPass;
    if (lastPass && since < SETTLE_MS) { schedule(SETTLE_MS - since); return; }

    if (passes >= MAX_PASSES) { giveUp(left); return; }

    passes++;
    lastPass = Date.now();
    if (!runPass()) { giveUp(left); return; }   /* app or jQuery absent */
    schedule(SETTLE_MS);
  }

  function nudge() {
    clearTimeout(quietTimer);
    quietTimer = setTimeout(check, QUIET_MS);
  }

  var watched = null;
  function watch() {
    var el = document.getElementById('CartDrawer');
    if (!el || el === watched) return;
    watched = el;
    /* Covers every drawer rebuild without having to know which event
       the theme used. Our own decoration re-fires this, but check()
       then finds nothing bare and stops. Snapshot immediately (not on
       the debounce) so freshly rendered prices are captured before the
       app can rewrite them. */
    new MutationObserver(function () {
      /* Both run inline rather than on the debounce: snapshot must beat
         the app to the raw prices, and verify must pull a wrong price
         back off the screen within a frame rather than a quarter second.
         Both are idempotent, so the mutations they cause settle at once. */
      snapshot();
      verify();
      nudge();
    }).observe(el, { childList: true, subtree: true });
    snapshot();
  }

  /* ============================================================
     QUICK VIEW MODAL price (4 Aug) — same problem, same rules.

     The quick view fetches the product form AFTER page load
     (theme.preloadProductModal on first hover, then the block
     fetch in Product.openModalProduct), so the Dual Price app's
     scan — which ran once at load — has never seen that DOM. The
     modal therefore showed a bare "£5.03": the INC VAT figure with
     no label, which reads as if the item costs more than the same
     product does on its own PDP ("£4.19 Ex VAT / £5.03 Inc VAT").

     Re-running the app does NOT fix it, and this was verified on
     staging rather than assumed: the app's catalogue scan only
     decorates prices it can tie to an `a[href*="products/"]`, and
     its PDP path (renderProductDetail, dp_price_path
     ".product-block--price") only runs for `productDPHandle` — the
     handle of the page you are actually on, which on a collection
     or home page is not the quick view's product. A manual
     runDisplayDualPrice with productDPHandle cleared leaves the
     modal price untouched.

     Forcing the PDP path by setting productDPHandle to the modal's
     handle was rejected deliberately: renderProductDetail REPLACES
     the whole `.product-block--price`, destroying the
     `[data-product-price]` node the theme rewrites on variant
     change — the price would then go stale (and silently wrong) the
     moment a shopper picked "Box of 50".

     So we use the established sibling mirror instead: copy what the
     app itself did to a price it DID decorate on this page (same
     ratio, same labels, same classes), applied to the money value
     the THEME rendered — which is always the selected variant's.
     NOVAT trade logins are safe by construction: the mirror only
     runs when the app has produced a two-line price somewhere on
     the page this session, and a NOVAT page has none anywhere.
     ============================================================ */
  var QV_SEL = '.modal--quick-shop .product-block--price .dualPrice';
  var qvTimer = null;

  /* v2 (25 Aug, Sam: cow trending QV showed bare "£5.03", capybara
     collection QV "Ex VAT" with no Inc line — "very inconsistent").
     The 4 Aug finding above ("re-running the app does NOT fix it") no
     longer holds: the app has been updated since, and one manual
     runDisplayDualPrice([jQuery]) call now decorates a modal price
     IN PLACE from the span's own value — verified live on the cow
     modal (bare £5.03 → £4.19 Ex VAT / £5.03 Inc VAT). So the modal
     now ASKS THE APP FIRST; the mirror below stays as fallback. This
     also fixes the homepage case the mirror could never reach: its
     NOVAT gate (qvAppDecorated) requires an app-decorated dual price
     somewhere on the page, and the homepage has none — so trending
     quick views stayed bare unless one of the app's own
     interaction-triggered passes happened to run first (why it
     "sometimes" worked). Once the app decorates the modal, the gate
     passes and the mirror's fpFix/height-reservation apply as before. */
  function qvAppRun() {
    if (typeof window.runDisplayDualPrice !== 'function' || !window.jQuery) return;
    var bare = false;
    document.querySelectorAll(QV_SEL).forEach(function (el) {
      if (el.classList.contains('nonTaxableVariant')) return;   /* zero-rated: single price IS the finished state */
      if (!el.querySelector('.firstPrice, .secondPrice')) bare = true;
    });
    if (!bare) return;
    try { window.runDisplayDualPrice([window.jQuery]); } catch (e) { /* app internals changed — mirror still covers it */ }
  }

  /* Proof the app rendered DUAL markup this session. Our own mirrored
     output is excluded so it can never bootstrap itself. */
  function qvAppDecorated() {
    var nodes = document.querySelectorAll('.dualPrice');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].hasAttribute('data-dss-dp-mirrored')) continue;
      if (nodes[i].querySelector('.firstPriceValue') &&
          nodes[i].querySelector('.secondPriceValue')) return true;
    }
    return false;
  }

  function qvDecorate() {
    if (!qvAppDecorated()) return;      /* NOVAT, or app absent — do nothing */
    /* Dual pricing is active this session: reserve the two-line price
       height in every QV modal (CSS keys off this class) so the theme's
       bare one-line rewrite on variant change -> late two-line
       decoration never shifts the modal content (trending QV pop). */
    document.querySelectorAll('.modal--quick-shop').forEach(function (m) {
      m.classList.add('dss-qv-dualprice');
    });
    var model = mirrorModel();
    if (!model) return;
    document.querySelectorAll(QV_SEL).forEach(function (el) {
      if (el.classList.contains('nonTaxableVariant')) return;   /* zero-rated: qvZeroFix owns it — a mirror rewrite here would ping-pong */
      /* The app injects an ID-scoped "#shopify-section-... .firstPrice
         {display:none !important}" for its single-price-on-collections
         setting, and a QV modal opened from a collection lives INSIDE
         that section — no class selector can outrank an ID, so the Inc
         line must be un-hidden inline (Sam, 14 Aug). */
      var fpFix = el.querySelector('.firstPrice');
      if (fpFix) fpFix.style.setProperty('display', 'block', 'important');
      if (el.querySelector('.firstPrice, .secondPrice')) return;   /* already done */
      /* The rendered bare figure is the STORED price — Inc on an inc-VAT
         store, Ex on an ex-VAT store (dss_vat_basis); the helper derives the
         other line with the app's own ratio (13 Oct 2026). */
      var stored = pence(el.textContent);
      if (stored === null) return;
      var exPence = Math.round(window.DSS_VAT.ex(stored, true, model.ratio));
      var incPence = Math.round(window.DSS_VAT.inc(stored, true, model.ratio));
      var fmt = function (p) {
        try { return window.Shopify.formatMoney(p, window.dp_money_format); }
        catch (e) { return null; }
      };
      var exTxt = fmt(exPence), incTxt = fmt(incPence);
      if (!exTxt || !incTxt) return;
      el.innerHTML =
        '<span class="secondPrice"><span class="secondPriceValue">' + exTxt + '</span> ' +
        '<span class="secondPriceLabel">' + model.exLabel + '</span></span><br>' +
        '<span class="firstPrice"><span class="firstPriceValue">' + incTxt + '</span> ' +
        '<span class="firstPriceLabel">' + model.incLabel + '</span></span>';
      el.querySelector('.firstPrice').style.setProperty('display', 'block', 'important');  /* see fpFix above */
      el.classList.add('dp_catalog');    /* stops the app re-processing it */
      el.setAttribute('data-dss-dp-mirrored', '1');
    });
  }

  /* ZERO-RATED GUARD (25 Aug, Sam: baby grow QV showed "£4.50 Ex VAT /
     £5.40 Inc VAT" — baby clothing is zero-rated, the only right
     display is the single stored £5.40; the fabricated Ex line was
     UNDER the real price). Neither the app's in-place modal pass nor
     the mirror checks variant.taxable — both assume taxable and derive
     an Ex line with the VAT ratio. The bug was LATENT: before the trigger rework
     above, zero-rated quick views simply stayed bare (single price) by
     accident, so reliable decoration exposed it. Source of truth is
     synchronous and already in the modal: the dssPackData / dssLlData
     JSON islands our Liquid renders carry variant.taxable. If the
     SELECTED variant (live master select, not the landing variant) is
     non-taxable, the price reverts to the single stored figure and the
     node is marked dp_catalog + nonTaxableVariant so no pass touches it
     again. A theme variant rewrite replaces the span wholesale, so a
     mixed-taxability product re-evaluates on every switch. Products
     with no island at all are left alone (taxable assumed — every
     multi-variant product carries one of the two islands). */
  function qvZeroFix() {
    document.querySelectorAll('.modal--quick-shop').forEach(function (m) {
      var el = m.querySelector('.product-block--price .dualPrice');
      if (!el || !el.querySelector('.firstPrice, .secondPrice')) return;   /* single already — nothing to revert */
      var holder = m.querySelector('[id^="QuickShopHolder-"]') || m;
      var sel = holder.querySelector('select[name="id"]');
      var vid = sel ? parseInt(sel.value, 10) : null;
      var found = null;
      var islands = holder.querySelectorAll('script[type="application/json"]');
      for (var i = 0; i < islands.length && !found; i++) {
        var txt = islands[i].textContent;
        if (txt.indexOf('"taxable"') === -1) continue;
        var data;
        try { data = JSON.parse(txt); } catch (e) { continue; }
        var vars = data.variants || (data.currentVariant ? [data.currentVariant] : []);
        if (!vid && data.currentVariantId) vid = data.currentVariantId;
        for (var j = 0; j < vars.length; j++) {
          if (!vid || vars[j].id === vid) { found = vars[j]; break; }
        }
      }
      if (!found || found.taxable !== false) return;   /* taxable or unknown — leave alone */
      var fmt = null;
      try { fmt = window.Shopify.formatMoney(found.price, window.dp_money_format); } catch (e) {}
      if (!fmt) return;
      el.innerHTML = fmt;
      el.classList.add('dp_catalog');            /* stops the app re-processing it */
      el.classList.add('nonTaxableVariant');     /* the app's own marker — existing pins keep it visible */
      el.setAttribute('data-dss-dp-zerorated', '1');
    });
  }

  function qvNudge() {
    clearTimeout(qvTimer);
    qvTimer = setTimeout(function () { qvAppRun(); qvDecorate(); qvZeroFix(); }, 60);
  }

  /* Watch each modal's price block: the theme rewrites it with a fresh
     bare <span class="dualPrice"> on every variant change (its client-side
     money format carries the same wrapper the server one does), so the
     mirror has to run again each time. Our own write re-fires this, but
     the second pass finds the line already decorated and stops. */
  function qvWatch(modal) {
    if (!modal) return;
    /* the price block itself, not the whole modal — the gallery/slideshow
       inside would otherwise fire this observer continuously */
    var block = modal.querySelector('.product-block--price');
    if (!block || block.dataset.dssQvDp) return;
    block.dataset.dssQvDp = '1';
    new MutationObserver(qvNudge).observe(block, { childList: true, subtree: true });
    qvNudge();
  }

  /* TRIGGER REWORK (25 Aug): quickview:loaded NO LONGER FIRES — since
     the 24 Aug product.modal.json edit (explicit blocks) the ?view=modal
     render arrives with its form inline, so theme.js skips the deferred
     blocks fetch whose completion dispatched that event, and this armour
     silently lost its only trigger. That is why prices "worked
     yesterday" and then didn't: with no trigger, only quick views whose
     content happened to land during the Dual Price app's ~9s boot churn
     still got decorated (verified live: cow modal opened early =
     decorated, opened a minute into the session = bare £5.03).
     Triggers now:
     (1) the theme's own modalOpen event — fires on EVERY modal open,
         blocks path or not;
     (2) a body-level observer, so PRELOADED holder content is decorated
         before the shopper even opens it (and the fpFix un-hide
         reapplies whenever the app's churn rewrites a price);
     (3) quickview:loaded kept, in case a future theme update revives
         the deferred-blocks path. */
  document.addEventListener('modalOpen', function () {
    var m = document.querySelector('.modal--quick-shop.modal--is-active');
    if (!m) return;
    qvWatch(m);
    qvNudge();
    /* the app's decorate pass fetches product JSON — allow for it, twice */
    setTimeout(function () { qvAppRun(); qvDecorate(); qvZeroFix(); }, 1200);
    setTimeout(function () { qvAppRun(); qvDecorate(); qvZeroFix(); }, 3200);
  });

  document.addEventListener('quickview:loaded', function (evt) {
    var id = evt.detail && evt.detail.productId;
    var modal = id ? document.getElementById('QuickShopModal-' + id) : null;
    if (!modal) modal = document.querySelector('.modal--quick-shop');
    qvWatch(modal);
    /* the app's own 3s retry pass may still be running: try again after it */
    setTimeout(function () { qvAppRun(); qvDecorate(); qvZeroFix(); }, 1200);
    setTimeout(function () { qvAppRun(); qvDecorate(); qvZeroFix(); }, 3200);
  });

  /* any DOM addition that leaves a bare quick-view price gets a nudge —
     debounced, and self-terminating: once decorated there is no bare
     node, so mutations stop scheduling work */
  var qvBodyTimer = null;
  new MutationObserver(function () {
    if (qvBodyTimer) return;
    qvBodyTimer = setTimeout(function () {
      qvBodyTimer = null;
      var nodes = document.querySelectorAll(QV_SEL);
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].classList.contains('nonTaxableVariant')) continue;   /* zero-rated single price — finished */
        if (!nodes[i].querySelector('.firstPrice, .secondPrice')) { qvNudge(); return; }
      }
    }, 400);
  }).observe(document.body, { childList: true, subtree: true });

  function start() {
    watch();
    setTimeout(function () { watch(); nudge(); }, LOAD_MS);
  }

  document.addEventListener('cart:updated', nudge);
  document.addEventListener('cart:build', nudge);
  /* native theme add-to-cart success (drawer rebuild) */
  document.addEventListener('ajaxProduct:added', nudge);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ------------------------------------------------------------
   DSS: Trending Products carousel arrows
   (sections/custom-trending-products.liquid). Scroll-snap does
   the swiping; the arrows page the track left/right and grey
   out at either end. Re-inits on shopify:section:load so it
   keeps working inside the theme editor.
   ------------------------------------------------------------ */
(function () {
  function initTrendingCarousel(root) {
    var track = root.querySelector('[data-dss-tp-track]');
    var prev = root.querySelector('[data-dss-tp-prev]');
    var next = root.querySelector('[data-dss-tp-next]');
    if (!track || !prev || !next || root.dataset.dssTpReady) return;
    root.dataset.dssTpReady = '1';

    /* infinite loop: paging past either end wraps to the other side.
       Paging targets EXACT card offsets, never clientWidth increments:
       a viewport-width scrollBy lands BETWEEN snap points, and iOS
       Safari's mandatory-snap engine fights the smooth scroll — on the
       8-card 3-up mobile grid the end state rested mis-snapped (sliver
       of card 6 + right gap, Sam's iPhone 18 Aug). Every target below
       is a card start (or the clamped max, itself card 6's start), so
       snap and scroll always agree. */
    function page(dir) {
      var cards = track.children;
      if (!cards.length) return;
      var max = track.scrollWidth - track.clientWidth;
      if (dir > 0 && track.scrollLeft >= max - 2) {
        track.scrollTo({ left: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        return;
      }
      if (dir < 0 && track.scrollLeft <= 2) {
        track.scrollTo({ left: max, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        return;
      }
      var pitch = cards.length > 1
        ? cards[1].offsetLeft - cards[0].offsetLeft
        : cards[0].offsetWidth;
      if (pitch <= 0) pitch = track.clientWidth;
      var perView = Math.max(1, Math.round(track.clientWidth / pitch));
      var current = Math.round(track.scrollLeft / pitch);
      var target = (current + dir * perView) * pitch;
      track.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
  }

    /* Interim-chevron handoff: html.dss-globo-styled flips the theme's
     pre-drawn nav carets off in the same frame Globo's own styling
     lands (detected by the retractor span gaining its styled width). */
  /* Self-hosted Lato must WIN the @font-face cascade. Globo injects its
     own Google-Lato stylesheet into <body> at runtime — later in document
     order than our head declaration, so theirs (two network hops, the
     hard-refresh flicker) would take over. When their link appears, move
     our declaration after it: last same-family @font-face wins, and the
     browser keeps using the preloaded same-origin files. */
  /* Globo menu icons are requested at 35px (`_35x.png`) for a 28px slot: on a 3x phone that is a 35px image
     stretched over 84 device pixels, and the drawer icons look blurred (Sam, 24 Sep 2026). Re-request each icon
     at three times the size once Globo has drawn the menu; Globo re-renders on open, so keep watching. The CDN
     honours the `_{n}x` suffix, so this is a URL rewrite, not a new asset. */
  (function sharpenGloboIcons() {
    var RE = /_(\d{2,3})x\.(png|jpe?g|webp|gif)(\?|$)/;
    function sharpen(root) {
      var imgs = (root || document).querySelectorAll('.gm-icon-img img, .gm-icon img');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i], src = img.getAttribute('src') || '';
        var m = RE.exec(src);
        if (!m || img.dataset.dssSharp) continue;
        var n = parseInt(m[1], 10);
        if (n >= 100) { img.dataset.dssSharp = '1'; continue; }
        img.dataset.dssSharp = '1';
        img.removeAttribute('sizes');
        img.setAttribute('src', src.replace(RE, '_' + (n * 3) + 'x.$2$3'));
      }
    }
    sharpen();
    if (!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sharpen(); });
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* 24 Sep 2026 (W-S5): on the cart page the theme rewrites [data-subtotal] with a bare stored-basis figure after
     every quantity change. cart.ajax.liquid ships the Ex + Inc version hidden inside the rebuilt items; put it back. */
  (function restoreCartTotal() {
    var forms = [document.getElementById('CartPageForm'), document.getElementById('CartDrawerForm')].filter(Boolean);
    if (!forms.length) return;
    function restore() {
      forms.forEach(function (form) {
        var src = form.querySelector('[data-dss-cart-total]');
        var dst = form.querySelector('[data-subtotal]');
        if (!src || !dst || dst.querySelector('.dss-cart-total')) return;
        dst.innerHTML = src.innerHTML;
      });
    }
    document.addEventListener('cart:updated', function () { setTimeout(restore, 0); setTimeout(restore, 300); });
    if ('MutationObserver' in window) {
      forms.forEach(function (form) {
        var dst = form.querySelector('[data-subtotal]');
        if (dst) new MutationObserver(function () { if (!dst.querySelector('.dss-cart-total')) restore(); }).observe(dst, { childList: true });
      });
    }
  })();

  (function reassertLato(tries) {
    var ours = document.getElementById('dss-lato-faces');
    if (!ours) return;
    var theirs = [].slice.call(document.querySelectorAll('link[href*="fonts.googleapis"]'))
      .filter(function (l) { return /Lato/i.test(l.href); }).pop();
    if (theirs && theirs.compareDocumentPosition(ours) & Node.DOCUMENT_POSITION_PRECEDING) {
      theirs.parentNode.insertBefore(ours, theirs.nextSibling);
      return;
    }
    if ((tries || 0) < 40) setTimeout(function () { reassertLato((tries || 0) + 1); }, 250);
  })(0);

  /* FAIL-OPEN WATCHDOG (5 Aug): everything in the nav workaround stack
     fails soft to visuals EXCEPT one case — if this file's fold logic
     dies or a Globo update restructures the markup beyond recognition,
     the pre-ready hides/nowrap could leave PLUSH TOYS + REWARDS hidden
     or clipped at mid widths. After 6s without a settled nav, fail
     open: mark ready (releases every static hide) and allow wrapping
     (.dss-nav-failopen in custom.css). Two ugly rows beat missing
     menu items. */
  setTimeout(function () {
    var tb = document.querySelector('.toolbar');
    if (!tb) return;
    if (!tb.classList.contains('dss-nav-ready')) {
      tb.classList.add('dss-nav-ready', 'dss-nav-failopen');
      document.documentElement.classList.add('dss-nav-failopen');
    }
  }, 6000);

  function initAll() {
    document.querySelectorAll('[data-dss-tp]').forEach(initTrendingCarousel);

    /* Quick view on trending cards: same lazy pattern as theme.initQuickShop
       (which only scans .grid-product) — first hover/focus preloads the
       product form into the card's quick-shop modal and arms the button.
       Desktop only, exactly like collections.
       The theme checks live at HOVER time, not here: this initAll can run
       before theme.js has defined preloadProductModal (script-order race —
       it bit on 4 Aug: the guard evaluated false once and no listener was
       ever attached, so trending quick view silently never armed). */
    document.querySelectorAll('.dss-tp__card[data-product-handle]').forEach(function (card) {
      function armQuickView() {
        if (!window.theme || !theme.settings || !theme.settings.quickView ||
            typeof theme.preloadProductModal !== 'function') return;  /* retry on next hover */
        if (theme.config && theme.config.bpSmall) return;   /* no quick view on mobile bp */
        card.removeEventListener('mouseover', armQuickView);
        card.removeEventListener('focusin', armQuickView);
        theme.preloadProductModal(
          card.dataset.productHandle,
          card.dataset.productId,
          card.querySelector('.quick-product__btn')
        );
        /* Tag this modal as trending-opened so CSS can differ from the
           collection quick view (delivery banner hidden here only). */
        var mid = 'QuickShopModal-' + card.dataset.productId;
        var tag = function () {
          var m = document.getElementById(mid);
          if (m) { m.classList.add('dss-qv-from-trending'); return true; }
          return false;
        };
        if (!tag()) {
          var tries = 0;
          var t = setInterval(function () {
            if (tag() || ++tries > 20) clearInterval(t);
          }, 150);
        }
      }
      card.addEventListener('mouseover', armQuickView);
      card.addEventListener('focusin', armQuickView);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

/* ------------------------------------------------------------
   DSS: PDP favourites heart (after the product title).
   Proxies the click to the Klaviyo Customer Hub favourites
   button rendered by the app block under the buy buttons; if
   the app element isn't on the page, the anchor's own
   #k-hub/favorites href opens the hub instead.
   ------------------------------------------------------------ */
document.addEventListener('click', function (e) {
  var heart = e.target.closest('[data-dss-pdp-fav]');
  if (!heart) return;
  var kl = document.querySelector('klaviyo-favorites-button');
  if (!kl) return; /* fall through to the href */
  var btn = kl.querySelector('button') ||
    (kl.shadowRoot && kl.shadowRoot.querySelector('button')) || kl;
  e.preventDefault();
  /* The app opens its full hub drawer on every click. While we wait to
     see whether the toggle succeeds, the drawer is kept INVISIBLE (html
     class + CSS) so it never flashes. Success (button label flips
     add<->remove): close the still-invisible drawer — the floating hub
     bubble is the only feedback, like the old site. No flip after 1.6s
     means the sign-in flow is needed: reveal the drawer instead. */
  var before = btn.textContent;
  var removing = /remove/i.test(before);
  document.documentElement.classList.add('dss-fav-pending');
  /* Removing a favourite: also mute the floating bubble for a moment —
     its only animation reads as "added", which is wrong on removal. */
  if (removing) {
    document.documentElement.classList.add('dss-fav-quiet');
    setTimeout(function () {
      document.documentElement.classList.remove('dss-fav-quiet');
    }, 2800);
  }
  var reveal = function () { document.documentElement.classList.remove('dss-fav-pending'); };
  btn.click();
  var api = window.customerHubApi;
  if (!api || typeof api.close !== 'function') { reveal(); return; }
  var waited = 0;
  var poll = setInterval(function () {
    waited += 80;
    if (btn.textContent !== before) {
      clearInterval(poll);
      api.close();
      setTimeout(function () { api.close(); }, 250);
      setTimeout(reveal, 600); /* after the close has settled */
    } else if (waited >= 1600) {
      clearInterval(poll);
      reveal(); /* sign-in drawer becomes visible */
    }
  }, 80);
});

/* ------------------------------------------------------------
   DSS: PDP heart state mirror. The Klaviyo favourites button is
   visually hidden (the heart proxies to it), so mirror its
   toggle state onto the heart: filled orange while the product
   is favourited, outline otherwise. The app button's own text
   ("Add to favourites" / "Remove from favourites") is the
   source of truth.
   ------------------------------------------------------------ */
(function () {
  function syncHeart() {
    var hearts = document.querySelectorAll('[data-dss-pdp-fav]');
    var kl = document.querySelector('klaviyo-favorites-button');
    if (!hearts.length || !kl) return;
    var btn = kl.querySelector('button') ||
      (kl.shadowRoot && kl.shadowRoot.querySelector('button'));
    if (!btn) return;
    var label = (btn.getAttribute('aria-label') || '') + ' ' + btn.textContent;
    var active = /remove/i.test(label);
    hearts.forEach(function (h) {
      h.classList.toggle('dss-pdp-fav--active', active);
      /* ONE state signal (board 3 accessibility, 18 Sep 2026): the name says what pressing will do. aria-pressed on top
         of a changing name announced "Remove from favourites, pressed" — two signals, and invalid on a link. */
      h.setAttribute('aria-label', active ? 'Remove from favourites' : 'Add to favourites');
      h.removeAttribute('aria-pressed');
    });
    /* the Klaviyo drawer is deliberately suppressed, so nothing told a screen-reader user the save happened:
       say it in the stock line's polite status region, only on a real change (not on first sync) */
    if (syncHeart.last !== undefined && syncHeart.last !== active) {
      var live = document.querySelector('.product-section [role="status"]');
      if (live) live.textContent = active ? 'Added to favourites' : 'Removed from favourites';
    }
    syncHeart.last = active;
  }

  /* role=button promises Space as well as Enter */
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    var h = e.target.closest && e.target.closest('[data-dss-pdp-fav][role="button"]');
    if (!h) return;
    e.preventDefault();
    h.click();
  });

  function init() {
    var kl = document.querySelector('klaviyo-favorites-button');
    if (!kl) return;
    new MutationObserver(syncHeart).observe(kl, {
      subtree: true, childList: true, characterData: true, attributes: true
    });
    syncHeart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* the app element may mount after us */
  var tries = 0;
  var t = setInterval(function () {
    if (document.querySelector('klaviyo-favorites-button') || ++tries > 20) {
      clearInterval(t); init();
    }
  }, 500);
})();

/* build: 4 Aug hover-guard fix */

/* ============================================================
   PRODUCT — Pack Size row picker (snippet
   custom-pack-size-picker.liquid, rendered by
   product-template.liquid for the option named "Pack Size").

   Fills each row with its Ex VAT total, Ex VAT per-unit price and a
   floored "SAVE n%" bubble measured against the qty-1 row of the SAME
   other-option combination. Supersedes the single pack-savings line
   (above) on Pack Size products; that line is guarded off in Liquid.

   Why the numbers are written here and not in Liquid: they are DERIVED
   figures. The Dual Price Display PRO app hooks the shop money format,
   so anything rendered through `| money` (or theme.Currency.formatMoney)
   comes out wrapped in <span class="dualPrice"> and the app then rewrites
   it into its own Ex/Inc pair. These are bare strings by construction —
   which also means NOVAT trade customers, who deliberately see Ex VAT
   only, see exactly the same rows as everyone else.

   Everything is stateless and delegated on `document`, keyed on data-
   attributes only: the quick-view id rewriter renames every id in the
   modal (appends "-modal"), so ids can never be used for keying.
   ============================================================ */
(function () {
  /* Every figure in the picker is the Ex VAT one, matching the bold Ex VAT
     figure in the price block — from DSS_VAT.ex, the one VAT helper (follows
     dss_vat_basis: inc storage takes VAT off, ex storage is as stored).
     Zero-rated products (variant.taxable === false, e.g. children's
     clothing) carry NO VAT — taking it off would fabricate an Ex VAT figure
     ~17% below what the customer pays (pyjamas bug, 14 Aug). Older cached
     islands lack the flag; only an explicit false counts as zero-rated. */
  function exOf(variant) {
    return window.DSS_VAT.ex(variant.price, variant && variant.taxable);
  }

  var SELECTOR = '[data-dss-pack-picker]';

  /* Quantity implied by a Pack Size option value: "Single" → 1,
     "Box of 18" / "Pallet of 360 (not individually gift boxed)" → 18/360,
     "50 Pack" → 50, bare "50" → 50. null = not parseable. */
  function packQty(value) {
    if (!value) return null;
    var t = String(value).trim();
    if (/(^|\/\s*)single\b/i.test(t)) return 1;
    var m = t.match(/(?:pack|box|bundle|set|pallet|case)\s+of\s+(\d+)/i) ||
            t.match(/(?:^|\/\s*)(\d+)\s*(?:pack|pk|pcs|pieces)\b/i);
    if (m) return parseInt(m[1], 10);
    if (/^\d+$/.test(t)) return parseInt(t, 10);
    return null;
  }

  /* bare format — never theme.Currency.formatMoney (see header) */
  function money(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function parseIsland(wrapper) {
    var el = wrapper.querySelector('[data-dss-pack-picker-data]');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      if (!data || !data.variants || !data.variants.length || !data.packOptionIndex) return null;
      return data;
    } catch (err) {
      return null;
    }
  }

  /* The product form this picker belongs to. On a PDP the quick-view modal
     for the same product can also be in the DOM, so never search globally. */
  function scopeOf(wrapper) {
    return wrapper.closest('[data-product-blocks]') ||
           wrapper.closest('.product-single') ||
           wrapper.closest('.product-section') ||
           wrapper.parentElement;
  }

  /* Currently checked values of every OTHER variant option, read live from
     the DOM — that is what makes repricing stateless and safe to re-run. */
  function otherSelections(wrapper, packKey) {
    var out = {};
    var scope = scopeOf(wrapper);
    if (!scope) return out;
    scope.querySelectorAll('.variant-input-wrap').forEach(function (group) {
      var key = group.dataset.index;
      if (!key || key === packKey) return;
      var checked = group.querySelector('input[data-variant-input]:checked');
      if (checked) {
        out[key] = checked.value;
      } else {
        var sel = group.querySelector('select[data-variant-input], select');
        if (sel) out[key] = sel.value;
      }
    });
    return out;
  }

  function matchVariant(variants, packIdx, packValue, others) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.options || v.options[packIdx - 1] !== packValue) continue;
      var ok = true;
      Object.keys(others).forEach(function (key) {
        var n = parseInt(key.replace('option', ''), 10);
        if (!n || n === packIdx) return;
        if (v.options[n - 1] !== others[key]) ok = false;
      });
      if (ok) return v;
    }
    return null;
  }

  function setText(el, text) {
    if (!el) return;
    el.textContent = text || '';
  }

  function fillSave(el, pct) {
    if (!el) return;
    el.textContent = '';
    if (pct === null) {
      el.hidden = true;
      return;
    }
    var word = document.createElement('span');
    word.className = 'dss-pack-picker__save-word';
    word.textContent = 'SAVE';
    var num = document.createElement('span');
    num.className = 'dss-pack-picker__save-pct';
    num.textContent = pct + '%';
    el.appendChild(word);
    el.appendChild(num);
    el.hidden = false;
  }

  function repriceRows(wrapper) {
    var data = parseIsland(wrapper);
    if (!data) return;

    var packIdx = data.packOptionIndex;
    var packKey = 'option' + packIdx;
    var others = otherSelections(wrapper, packKey);
    var rows = wrapper.querySelectorAll('.variant-input[data-value]');

    /* Baseline: the qty-1 variant of the SAME other-option combination.
       Products with no Single (pallet-only ladders, "Pack of 10"
       minimums — Sam, 19 Aug) fall back to their SMALLEST parseable
       pack: that is what the buyer would otherwise order, so bigger
       packs still earn an honest bubble. The baseline row itself never
       shows one (it cannot beat its own per-unit price, and the
       strict `<` below already guarantees that). A qty-1 row always
       wins over any fallback. No usable baseline at all (or price 0)
       → no bubbles, per-unit stays. */
    var basePerUnitEx = null;
    var baseQty = null;
    for (var i = 0; i < rows.length; i++) {
      var q = packQty(rows[i].dataset.value);
      if (!q || q <= 0) continue;
      if (baseQty !== null && q >= baseQty) continue;
      var baseVariant = matchVariant(data.variants, packIdx, rows[i].dataset.value, others);
      if (baseVariant && baseVariant.price > 0) {
        baseQty = q;
        basePerUnitEx = exOf(baseVariant) / q;
      }
      if (baseQty === 1) break;
    }

    rows.forEach(function (row) {
      var value = row.dataset.value;
      var totalEl = row.querySelector('[data-pack-total]');
      var eachEl = row.querySelector('[data-pack-each]');
      var saveEl = row.querySelector('[data-pack-save]');
      var subEl = row.querySelector('[data-pack-sublabel]');
      var variant = matchVariant(data.variants, packIdx, value, others);

      /* sub-label: variant metafield custom.pack_sub_label, blank → hidden */
      if (subEl) {
        var sub = variant && variant.sublabel ? String(variant.sublabel).trim() : '';
        subEl.textContent = sub;
        subEl.hidden = !sub;
      }

      /* no variant for this combination (sparse matrix) */
      if (!variant) {
        setText(totalEl, '–');
        setText(eachEl, '');
        fillSave(saveEl, null);
        return;
      }

      /* free / zero-priced → render nothing rather than "£0.00" */
      if (!variant.price || variant.price <= 0) {
        setText(totalEl, '');
        setText(eachEl, '');
        fillSave(saveEl, null);
        return;
      }

      var totalEx = exOf(variant);
      var qty = packQty(value);

      if (!qty || qty <= 0) {
        /* unparseable pack size → total only, no per-unit claim */
        setText(totalEl, money(totalEx));
        setText(eachEl, '');
        fillSave(saveEl, null);
        return;
      }

      var perUnitEx = Math.ceil(Math.round(totalEx) / qty - 1e-6);   /* 5 Oct 2026: divide the DISPLAYED (penny-rounded) total — £157.44 / 48 is exactly £3.28, the unrounded £157.4417 tipped it to £3.29 */
      /* was: Math.ceil(totalEx / qty - 1e-6) */   /* to the penny, rounded UP (Sam, 22 Sep 2026): never quote less per item than the pack costs */

      if (qty === 1) {
        /* the Single row shows the unit price only — a total would repeat it */
        setText(totalEl, '');
        setText(eachEl, money(Math.round(totalEx)) + ' each');   /* 5 Oct 2026: a Single IS the price, so round like the headline (£4.19), not up (it read £4.20 beside a £4.19 headline) */
        fillSave(saveEl, null);
        return;
      }

      setText(totalEl, money(totalEx));
      setText(eachEl, money(perUnitEx) + ' each');

      var pct = null;
      if (basePerUnitEx && basePerUnitEx > 0 && perUnitEx < basePerUnitEx) {
        /* floored, per Sam: never overstate the saving */
        var floored = Math.floor((1 - perUnitEx / basePerUnitEx) * 100);
        if (floored >= 1) pct = floored;
      }
      fillSave(saveEl, pct);
    });
  }

  function initPicker(wrapper) {
    if (!wrapper) return;
    /* double-init guard: repricing is idempotent, this just avoids churn
       when several triggers land at once */
    if (wrapper.dataset.dssPackReady !== '1') wrapper.dataset.dssPackReady = '1';
    repriceRows(wrapper);
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initPicker);
  }

  /* Stateless → a global refresh is always safe and always correct. */
  document.addEventListener('variant:change', function () {
    initAll(document);
  });

  /* Quick view: the picker markup is lifted into the modal by theme.js and
     its JSON island comes with it (inline <script> would not run). Same
     event the QV dual-price mirror uses — do not touch that mirror. */
  document.addEventListener('quickview:loaded', function (evt) {
    var id = evt.detail && evt.detail.productId;
    var modal = id ? document.getElementById('QuickShopModal-' + id) : null;
    if (!modal) modal = document.querySelector('.modal--quick-shop');
    initAll(modal || document);
  });

  /* theme editor re-renders sections in place */
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
})();

/* --------------------------------------------------------------------------
   DRAWER — freeze Globo's slide panel during outbound navigation.
   Globo's slide mode tears the panel down the instant a leaf link is
   tapped (state classes revert), snapping the drawer back to the main
   list at top before the next page paints — the "pops to the top" jump.
   Verified present on the LIVE site too (no custom code there): Globo
   behaviour, not theme code. Fix: on leaf-link taps, stop the click
   from reaching Globo's handlers; the browser's default navigation
   still proceeds and the menu stays exactly as it looks.
   Parent rows (gm-has-submenu) are untouched — their taps must keep
   reaching Globo to open the next panel.
   -------------------------------------------------------------------------- */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.drawer--left .mobile-nav a.gm-target');
    if (!a) return;
    var li = a.closest('.gm-item');
    if (!li || li.classList.contains('gm-has-submenu')) return; // panel opener, not a leaf
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return; // not a navigation
    e.stopPropagation(); // freeze the menu; navigation proceeds untouched
  }, true);
})();

/* --------------------------------------------------------------------------
   DRAWER — hard scroll isolation (mobile). While the nav drawer is open,
   the ONLY thing allowed to scroll is the drawer's own scroller. The
   theme's iOS "lock" prevents nothing (its touchmove handler returns
   true) and overflow locks are unreliable on iOS, so: block every
   touchmove that doesn't originate inside #NavDrawer's scroller.
   Companion CSS (custom.css) kills the desktop scrollbar/wheel via
   body{overflow:hidden} while open.
   -------------------------------------------------------------------------- */
(function () {
  /* An "open" slide sub-panel is one actually on screen: slide mode keeps
     closed panels rendered but translated off-canvas, so detection is
     geometric (on-viewport + sized), not class-based — robust across
     Globo updates. */
  function openSubmenu(drawer) {
    /* An open panel OVERLAPS THE DRAWER BOX. Testing against the viewport
       was wrong: closed panels sit translated right by the drawer's width,
       and on phones the drawer is narrower than the screen, so a CLOSED
       panel still poked into the viewport and passed — the gate then
       blocked ALL main-list scrolling (Sam, 18 Aug: couldn't reach
       Log in/Rewards/contact rows). */
    var d = drawer.getBoundingClientRect();
    var panels = drawer.querySelectorAll('.gm-submenu');
    for (var i = 0; i < panels.length; i++) {
      var r = panels[i].getBoundingClientRect();
      if (r.width > 40 && r.height > 40 &&
          r.left < d.right - 40 && r.right > d.left + 40) return panels[i];
    }
    return null;
  }
  document.addEventListener('touchmove', function (e) {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return;
    if (!(e.target.closest && e.target.closest('#NavDrawer .drawer__scrollable'))) {
      e.preventDefault();
      return;
    }
    /* Globo slide mode: while a sub-panel is open the OUTER list is still
       present (and visible below the panel — Rewards/contact rows). A swipe
       starting there scrolled the outer list underneath the open panel
       (Sam's iPhone, 18 Aug: swipe up from the very bottom pops out of the
       sub-menu). While a panel is open, only touches INSIDE a sub-panel
       may scroll. */
    if (openSubmenu(drawer) && !(e.target.closest && e.target.closest('.gm-submenu'))) {
      e.preventDefault();
    }
  }, { passive: false });
})();


/* --------------------------------------------------------------------------
   PDP — stock pill follows the selected variant (Sam, 10 Aug: pill was
   server-rendered once for the landing variant and never updated, so a
   search deep-link to an OOS pack variant left "Out of stock" showing
   even after switching to the in-stock Single).
   -------------------------------------------------------------------------- */
/* 17 Sep 2026 (review board 2): listen to the theme's container-level `variantChange` in the CAPTURE phase so the
   handler is scoped to the section that changed — the document-level `variant:change` let a quick-view variant
   change flip the page's own pill (and, since the sold-out state keys on the pill, the whole buy column). Also
   announces the change to assistive tech through the stock line's role="status" region. */
document.addEventListener('variantChange', function (event) {
  var v = event.detail && event.detail.variant;
  if (!v) return;
  var section = event.target && event.target.closest ? (event.target.closest('.product-section') || event.target) : null;
  if (!section || !section.querySelector) return;
  var pill = section.querySelector('.dss-stock-row .dss-stock-pill');
  if (!pill) return;
  var inStock = !!v.available;
  var was = pill.classList.contains('dss-stock-pill--in');
  pill.classList.toggle('dss-stock-pill--in', inStock);
  pill.classList.toggle('dss-stock-pill--out', !inStock);
  pill.textContent = inStock ? 'In stock' : 'Out of stock';
  /* 21 Sep 2026: the restock answer can differ per variant (variant Restock date). The map is printed by
     custom-delivery-banner.liquid as KIND§TEXT per variant id: date§mid October, due§any day now, plain§<as typed>. */
  var mapEl = section.querySelector('[data-dss-restock-map]');
  if (mapEl) {
    var map = {}; try { map = JSON.parse(mapEl.textContent); } catch (e) {}
    var r = String(map[v.id] || '').split('\u00a7'), kind = r[0], text = r[1] || '';
    var panel = section.querySelector('[data-dss-restock]'), title = section.querySelector('[data-dss-restock-title]');
    if (panel && title) {
      panel.setAttribute('data-on', text ? 'true' : 'false');
      title.textContent = '';
      if (kind === 'date' || kind === 'due') {
        title.appendChild(document.createTextNode(kind === 'date' ? 'Back in stock ' : 'Due '));
        var em = document.createElement('em'); em.textContent = text; title.appendChild(em);
      } else { title.textContent = text; }
    }
    var eta = section.querySelector('[data-dss-restock-eta]'), etaText = section.querySelector('[data-dss-restock-eta-text]');
    if (eta && etaText) {
      var short = kind === 'date' && text.length <= 24 ? 'Back ' + text : (kind === 'due' ? 'Due any day' : '');
      etaText.textContent = short;
      eta.setAttribute('data-on', short ? 'true' : 'false');
    }
  }
  var status = section.querySelector('[data-dss-stock-status]');
  if (status && was !== inStock) status.textContent = inStock ? 'This option is in stock and can be added to your basket.' : 'This option is out of stock. Add to basket is unavailable; you can ask to be told when it is back.';
}, true);

/* ============================================================
   FOLDER Product Tabs — mobile accordion jump fix (18 Aug 2026)
   The app's accordion is single-open: tapping a header COLLAPSES
   the previously-open panel, removing 300-700px of page above the
   tapped point (measured: -331px opening Pressing Instructions,
   -702px opening Videos after the auto-opened Description). Desktop
   Chrome masks this with native scroll anchoring; iOS Safari has
   none, so the whole page lurches — worst on the first taps, when
   the auto-opened (largest) Description panel is what collapses.
   Fix: manual scroll anchoring — pin the tapped header to its
   pre-toggle viewport position for the settle window. Where native
   anchoring already compensates the delta is 0 and this no-ops.
   ============================================================ */
(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 768px)'); /* app's accordion breakpoint */
  document.addEventListener('click', function (ev) {
    if (!mq.matches) return;
    if (Date.now() - (window.__dssTabJump || 0) < 900) return;   /* jump in progress: the pin would fight the jump's own scroll (Sam's top-and-back flick) */
    var head = ev.target && ev.target.closest && ev.target.closest('.smart-tabs-navigation-li');
    if (!head) return;
    var startTop = head.getBoundingClientRect().top;
    var t0 = performance.now();
    (function hold (now) {
      var d = head.getBoundingClientRect().top - startTop;
      if (Math.abs(d) > 0.5) window.scrollBy(0, d);
      if ((now || performance.now()) - t0 < 600) requestAnimationFrame(hold);
    })(t0);
  }, true);
})();

/* ============================================================
   PRODUCT GALLERY: mobile tap-to-zoom (Sam, 19 Aug). Desktop has
   always opened the lightbox from anywhere on the photo — vanilla
   stretches the zoom button invisibly over the whole image at
   ≥769px — but mobile only ever offered the small corner
   magnifier (identical in 7.5.2), while tap-the-image is what
   shoppers expect. A tap on a main-gallery image now presses that
   image's own zoom button. Swipes stay safe: a real drag never
   produces a click, and any that slip through arrive
   defaultPrevented (honoured below). The magnifier stays as the
   visible affordance; no-op where zoom is disabled (no button).
   ============================================================ */
(function () {
  document.addEventListener('click', function (evt) {
    if (window.innerWidth > 768) return;
    if (evt.defaultPrevented) return;
    var img = evt.target.closest('.product__main-photos .photoswipe__image');
    if (!img) return;
    var wrap = img.closest('.image-wrap');
    var btn = wrap && wrap.querySelector('.js-photoswipe__zoom');
    if (!btn || btn.contains(evt.target)) return; /* actual button press: let it run */
    evt.preventDefault();
    btn.click();
  });
})();


/* ============================================================
   PRESS FEEDBACK v2 (Sam, 22 Aug 2026 — "it doesn't do it on my
   laptop touchpad when I just tap, only on click"). The CSS :active
   dip only lives while the pointer is down, and a trackpad or phone
   tap is down-and-up in ~5ms — so most real presses never showed it.
   Now: pointerdown adds .dss-pressed (styled in custom.css) and keeps
   it for at least MIN_HOLD ms, then swaps to .dss-released for an
   eased return. Delegated, passive, no preventDefault, so clicks,
   drags and form submits are untouched. Reduced-motion users get
   nothing from here (the CSS blanket handles :active). The selector
   list is the single place to widen coverage.
   ============================================================ */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = [
    '.btn', '.dss-pack-picker__label', '.dss-header-search__btn', '.dss-qv-link',
    '.variant__button-label', '.pagination a', '.pagination button',
    '.site-nav__link--icon', '.js-qty__adjust', '.drawer__close-button', '.modal__close',
    '.btn--circle', '.dss-mobile-burger', '.cart__remove-btn', '.dss-pdp-fav', '.dss-tp__arrow',
    '.quick-product__btn', '.sticky-atc__btn', '.sticky-atc__qty-btn', '.pas__btn', '.pas__close', '.pas__copy',
    '.pas__native', '.social-sharing__link', '.footer__newsletter-btn', '.btn--search', '.btn--close-search', '.tool-tip__close',
    '.collection-item', '.dss-tp__link', '.logo-bar__link', '.yt-watch-link', '.yt-channel-btn',
    '.snize-action-button', '.snize-view-link', '.snize-pagination-next', '.snize-pagination-prev',
    '.gs--button'   /* Build-a-Gang-Sheet app CTA (gang-sheet PDPs) */
  ].join(',');
  var MIN_HOLD = 140, EASE_BACK = 150;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    var el = e.target.closest(SEL);
    if (!el || el.disabled) return;
    el.classList.remove('dss-released');
    el.classList.add('dss-pressed');
    el.__dssPressAt = performance.now();
  }, { capture: true, passive: true });
  function release() {
    var pressed = document.querySelectorAll('.dss-pressed');
    for (var i = 0; i < pressed.length; i++) (function (el) {
      var wait = Math.max(0, MIN_HOLD - (performance.now() - (el.__dssPressAt || 0)));
      setTimeout(function () {
        el.classList.remove('dss-pressed');
        el.classList.add('dss-released');
        setTimeout(function () { el.classList.remove('dss-released'); }, EASE_BACK);
      }, wait);
    })(pressed[i]);
  }
  document.addEventListener('pointerup', release, { capture: true, passive: true });
  document.addEventListener('pointercancel', release, { capture: true, passive: true });
  window.addEventListener('blur', release);
})();

/* ============================================================
   SEARCHANISE RESULTS (/pages/search-results-page) — Dual Price on the
   cards (21 Aug). The Dual Price app never saw Searchanise's cards: they
   render after the app's page-load scan, and their price span lacks the
   `.dualPrice` hook the app's catalogue scan looks for inside each
   product link — so search showed the STORED (Inc VAT) figure with no
   label while every other grid shows Ex VAT. Tag each card's price and
   re-run the app once per render. Its own jQuery isn't global on this
   page; any jQuery works for its getJSON/when (Globo's or Searchanise's).
   Gated to the results page; the observer watches only #snize_results.
   ============================================================ */
(function () {
  if (!/search-results-page/.test(location.pathname) && !document.getElementById('snize_results')) return;
  function getJQ() {
    return window.jQuery || window.gmjQuery || (window.Searchanise && window.Searchanise.$) || null;
  }
  var timer = null, waits = 0;
  function pass() {
    timer = null;
    /* "View product" hover button → into the photo wrapper, so CSS can pin it
       bottom-centre of the photo like the quick-view pill (its native home is a
       static .snize-buttons box under the text; the card's one <a> still wraps it) */
    document.querySelectorAll('#snize_results li.snize-product').forEach(function (li) {
      var b = li.querySelector('.snize-buttons .snize-view-product-button'), w = li.querySelector('.snize-thumbnail-wrapper');
      if (b && w) w.appendChild(b);
    });
    /* on desktop the QV fast-path decorates every pill-bearing card from
       its preload's own data (taxable-aware, no app involved, no hide
       cycles) — hand the app only the cards the fast-path cannot own.
       Touch devices have no preloads, so there the app lane still covers
       everything (its brief hide-while-fetching remains, as before). */
    /* 14 Oct 2026: native Ex/Inc display (custom-dual-price.js) decorates every card from the
       product JSON itself — no app lane to feed (the desktop fast path below still runs) */
    if (window.DSS_DUAL && window.DSS_DUAL.native) { if (window.DSS_DUAL.pass) window.DSS_DUAL.pass(); return; }
    var qvOwns = window.innerWidth > 768 && !document.documentElement.classList.contains('supports-touch');
    if (qvOwns) {
      /* DE-TAG (26 Aug, Sam: flashing again): the `:not(:has(.dss-snize-qv))`
         guard below is a RACE — on loads where this pass beat the pill scan,
         every card got tagged .dualPrice, and the app re-runs a hide/show
         pass on EVERY :input event (typing in the search box = all prices
         blink). A pill card's price is final once decorated, so strip the
         app's hook off it: the app selects by .dualPrice, so an untagged
         span can never be hidden again. Runs on every pass (the body
         observer fires through the app's churn), healing any leak ≤250ms
         after it appears. */
      document.querySelectorAll('#snize_results li.snize-product:has(.dss-snize-qv) .snize-price-list .snize-price.dualPrice').forEach(function (s) {
        if (s.classList.contains('dp_catalog') || s.querySelector('.secondPrice, .firstPrice')) {
          s.classList.remove('dualPrice');
          if (s.style.display === 'none') s.style.removeProperty('display');
        }
      });
      /* and close the race itself: if cards are up but the pill scan hasn't
         run yet, wait for it instead of tagging what it's about to own
         (bounded — if the QV block ever breaks, the app lane still takes over) */
      if (document.querySelector('#snize_results li.snize-product') && !document.querySelector('#snize_results .dss-snize-qv') && waits++ < 40) {
        timer = setTimeout(pass, 250);
        return;
      }
    }
    var spanSel = qvOwns
      ? '#snize_results li.snize-product:not(:has(.dss-snize-qv)) .snize-price-list .snize-price:not(.dualPrice):not(.dp_catalog)'
      : '#snize_results .snize-price-list .snize-price:not(.dualPrice):not(.dp_catalog)';
    var spans = document.querySelectorAll(spanSel);
    if (!spans.length) return;   /* nothing new — the app's own rewrites also trigger the observer */
    var jq = getJQ();
    if (!jq || typeof window.runDisplayDualPrice !== 'function') {
      /* Searchanise renders before the Dual Price script has defined its
         function; nothing mutates afterwards to re-trigger us — so wait for it */
      if (waits++ < 40) timer = setTimeout(pass, 500);
      return;
    }
    spans.forEach(function (s) { s.classList.add('dualPrice'); });
    try { window.runDisplayDualPrice([jq]); } catch (e) { /* app internals changed — leave search as is */ }
    /* The app hides every .dualPrice up front and re-shows only when its
       per-product fetches resolve; if they don't (rate limit, network), the
       prices would simply vanish. After a grace period, un-hide anything
       still hidden — the stored figure beats an empty slot. */
    setTimeout(function () {
      document.querySelectorAll('#snize_results .snize-price.dualPrice').forEach(function (el) {
        if (el.style.display === 'none') el.style.removeProperty('display');
      });
    }, 8000);
  }
  /* trailing THROTTLE, not a resettable debounce (25 Aug): other apps
     mutate the page continuously after load, and a debounce that resets
     per mutation starved this pass for seconds — the cards sat with the
     raw stored price long after render (Sam's screenshot). */
  function schedule() { if (timer) return; timer = setTimeout(pass, 250); }
  /* Watch the whole body (this page only): the widget replaces the
     #snize_results node on every render, so an observer on the node itself
     goes stale with it. Debounced, and pass() is a no-op once tagged. */
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();

/* ============================================================
   MOBILE PDP GALLERY VANISHING AFTER THE LIGHTBOX (22 Aug, Sam, iPhone:
   "enlarge the picture, come off, the photo disappears"). Reproduced with
   iPhone emulation, deterministic: the theme's iOS scroll-lock hides the
   whole page while PhotoSwipe is open (`.pswp-open-in-ios body>*
   {display:none}`). Swiping to another photo in the lightbox (or iOS
   firing `resize` as its toolbar hides) makes the theme call
   flickity.goToSlide(); the gallery's adaptiveHeight then measures the
   selected slide while the page is hidden — 0px — and pins the viewport
   to height:0. Closing restores the page but nothing re-measures, so the
   gallery stays collapsed (dots visible, photo gone). It used to recover
   when a late image load nudged Flickity; with every image now eager,
   nothing nudges it. Fix: when the lightbox closes, ask every product
   slideshow to re-measure. Watches the `.pswp` root's class (the theme
   renders one per page) — no theme JS touched.
   ============================================================ */
(function () {
  var pswp = document.querySelector('.pswp');
  if (!pswp) return;
  function remeasure() {
    if (!window.Flickity) return;
    document.querySelectorAll('.product-slideshow.flickity-enabled').forEach(function (el) {
      var fl = window.Flickity.data(el);
      if (fl) fl.resize();   /* recomputes cell sizes and, with adaptiveHeight, the viewport height */
    });
  }
  var wasOpen = pswp.classList.contains('pswp--open');
  new MutationObserver(function () {
    var open = pswp.classList.contains('pswp--open');
    if (wasOpen && !open) {
      /* the theme drops its html.pswp-open-in-ios class in PhotoSwipe's
         destroy listener, a beat after the class flips — measure after it */
      setTimeout(remeasure, 60);
      setTimeout(remeasure, 400);
    }
    wasOpen = open;
  }).observe(pswp, { attributes: true, attributeFilter: ['class'] });
})();

/* ============================================================
   MOBILE PDP GALLERY: position counter (22 Aug). The gallery's phone
   layout went from "partial" (75vw slides with the neighbours peeking in
   — Luke: doesn't like seeing the next/previous images) to "full"
   (one image at a time). Without the peek, the only hint that more
   photos exist is the dot row, so add the pattern the big stores use —
   a small "2 / 9" counter on the image (Baymard: a visible position
   counter is the reliable signpost for swipe galleries; dots alone are
   easy to miss). Reads Flickity's own select event; CSS hides it above
   768px where the thumbnails do the job. Sits bottom-left; the zoom
   magnifier keeps bottom-right.
   ============================================================ */
(function () {
  function setup(el) {
    if (el.__dssCounter || !window.Flickity) return;
    var fl = window.Flickity.data(el);
    if (!fl) return;
    var host = el.closest('.product__main-photos') || el;
    var pill = document.createElement('div');
    pill.className = 'dss-gallery-counter';
    pill.setAttribute('aria-hidden', 'true');
    host.appendChild(pill);
    // Pin the pill to the PHOTO's bottom edge, not the wrapper's: the wrapper
    // also holds the "Watch the how-to" chip under the photo (17 Sep 2026),
    // and a CSS bottom:12px put the counter on top of that chip on phones.
    var phone = window.matchMedia('(max-width: 768px)');
    function place() {
      if (host === el || !phone.matches) return;   // the pill is display:none above 768px — no layout reads there
      pill.style.bottom = 'auto';
      pill.style.top = (el.offsetTop + el.offsetHeight - 12 - pill.offsetHeight) + 'px';
    }
    function update() {
      var n = fl.cells.length;
      if (n < 2) { pill.hidden = true; return; }
      pill.hidden = false;
      pill.textContent = (fl.selectedIndex + 1) + ' / ' + n;
      place();
    }
    fl.on('select', update);
    // The slider's height ANIMATES to each photo (Flickity adaptiveHeight, .35s), so reading it on `select` pinned the
    // pill to the previous photo's edge on mixed-ratio galleries. A ResizeObserver follows the real height instead,
    // and replaces the window resize listener that was never removed (board 3 engineering, 18 Sep 2026).
    if (window.ResizeObserver) { new ResizeObserver(place).observe(el); }
    else { fl.on('settle', place); window.addEventListener('resize', place, { passive: true }); }
    update();
    el.__dssCounter = true;
  }
  function scan() { document.querySelectorAll('.product-slideshow.flickity-enabled').forEach(setup); }
  scan();
  /* the slideshow initialises after our script on a cold load (and again
     when a quick view or section re-renders) */
  var tries = 0, iv = setInterval(function () { scan(); if (++tries > 40) clearInterval(iv); }, 250);
  document.addEventListener('shopify:section:load', scan);
})();

/* ============================================================
   MOBILE PDP LIGHTBOX CLOSE: shrink back to the photo, not the top-left
   corner (22 Aug, Sam on iPhone). Same root cause as the vanishing
   gallery above: the theme's iOS scroll-lock hides the whole page while
   PhotoSwipe is open, and PhotoSwipe asks the theme's getThumbBoundsFn
   "where is the thumbnail?" at the instant the ✕ is pressed — the page
   is still hidden, the rect is 0×0 at 0,0, so the close animation flies
   to the top-left. Fix: wrap the PhotoSwipe constructor (resolved by the
   theme at open time) and, on iPhone/iPad only, answer with the photo
   frame's rect captured at OPEN time, when the page was visible. The
   theme restores the scroll position on destroy, so open-time viewport
   coordinates are the right target. Desktop and Android keep the theme's
   live measurement (no lock there, nothing to fix).
   ============================================================ */
(function () {
  if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;
  var Orig = window.PhotoSwipe;
  if (typeof Orig !== 'function') return;
  function Wrapped(el, ui, items, options) {
    options = options || {};
    /* the frame the user opened from — after a swipe in the lightbox the
       gallery shows the new photo in that SAME frame, so every index
       closes back to it (per-item rects would point at off-screen slides) */
    var opened = (items || [])[options.index] || (items || [])[0];
    var r = opened && opened.el && opened.el.getBoundingClientRect ? opened.el.getBoundingClientRect() : null;
    var frame = r && r.width ? { x: r.left, y: r.top + (window.pageYOffset || 0), w: r.width } : null;
    var themeFn = options.getThumbBoundsFn;
    options.getThumbBoundsFn = function (index) {
      var live = themeFn ? themeFn(index) : null;
      if (live && live.w) return live;               /* page visible (not locked) — theme's answer is right */
      return frame || live;
    };
    return new Orig(el, ui, items, options);
  }
  Wrapped.prototype = Orig.prototype;
  Object.keys(Orig).forEach(function (k) { try { Wrapped[k] = Orig[k]; } catch (e) {} });
  window.PhotoSwipe = Wrapped;
})();

/* ============================================================
   SEARCH FOCUS WITHOUT THE OVERLAY (24 Aug, Stuart on Android: caret in
   the search bar, keyboard up, no Searchanise overlay). Reproduced under
   emulation: the app opens its widget on tap/click ONLY, never on focus —
   so any focus that arrives without a click (an accidental long-press on
   the field, which places the caret but fires no click; or a tap in the
   first seconds before the app's script binds) leaves a bare native input.
   Fails safe (the form is a real GET /search fallback), but the instant
   overlay is the intended experience. Guard: when the input gains focus
   and no Searchanise widget is visible ~350ms later, hand the app the
   click it was waiting for. One retry per focus; no-op if the app is
   gone. ============================================================ */
(function () {
  var input = document.querySelector('.dss-header-search__input');
  if (!input) return;
  function widgetVisible() {
    var els = document.querySelectorAll('[class*="snize"], [id*="snize"]');
    for (var i = 0; i < els.length; i++) {
      var e = els[i], b = e.getBoundingClientRect();
      if (b.height > 150 && getComputedStyle(e).display !== 'none' && getComputedStyle(e).visibility !== 'hidden') return true;
    }
    return false;
  }
  /* v2 (Sam reproduced by tapping the instant the page loads): a single
     350ms nudge fizzled when the app's script was still downloading. Now
     the nudge RETRIES every 400ms for up to 10s while the input stays
     focused and no widget has appeared — the first nudge after the app
     binds is the one that lands. Also covers a tap so early that it beat
     this script: if the input is already focused when we run, start the
     same loop. */
  var timer = null;
  function nudgeLoop(triesLeft) {
    clearTimeout(timer);
    if (triesLeft <= 0) return;
    timer = setTimeout(function () {
      if (document.activeElement !== input || widgetVisible()) return;
      input.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
      input.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
      input.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      nudgeLoop(triesLeft - 1);
    }, 400);
  }
  input.addEventListener('focus', function () { nudgeLoop(25); });
  input.addEventListener('blur', function () { clearTimeout(timer); });
  if (document.activeElement === input) nudgeLoop(25);   /* the tap beat this script */
})();

/* ============================================================
   QUICK VIEW ON SEARCHANISE RESULTS — v4 (25 Aug; Sam: pill still slow
   after reload, stars black, no review count — "be ruthless").
   Recon on the live page found three real defects in v3:
   (1) pill insertion used a RESETTABLE debounce on body mutations —
       the Dual Price app mutates the page for ~9s after load, so the
       debounce kept pushing the first scan back and no pill existed to
       reveal on hover;
   (2) Searchanise REPLACES the results DOM on every re-render; the
       theme's click binding and btn--not-ready removal lived on the old
       button nodes, so re-inserted pills were permanently dead;
   (3) the Judge.me nudge called jdgm.init, which does not exist on this
       page (window.jdgm is only their loader stub here) — the badge
       arrives fully populated (rating, count, star spans) but wrapped in
       the app's own style="display:none", waiting for a script that
       never runs. Stars/count are now activated by scoped CSS instead
       (see .dss-qv-from-search jdgm rules) — zero Judge.me dependency.
   v4 architecture:
   - state lives in a pid-keyed map, never on DOM nodes;
   - per product a HIDDEN ANCHOR button (.dss-qv-anchor, appended to
     body next to the modal shell, so it survives every widget
     re-render) carries the theme's js-modal-open class; it exists
     before theme.Modals binds, so it is permanently clickable — the
     visible pill just proxies clicks to it;
   - ALL cards preload immediately after render (no waiting for scroll
     or hover), 3 fetches at a time in display order — first rows are
     ready in under a second, a full page in a few seconds; hover and
     click jump the queue;
   - scans are THROTTLED (leading edge + 250ms trailing), never starved
     by other apps' mutations;
   - a clicked-but-not-ready pill shows a spinner and auto-opens when
     the fetch lands; if it still is not ready 6s after the click, the
     shopper is taken to the product page instead — never a dead end.
   The modal shell/holder flow is unchanged (the theme's own quick-view
   machinery — see snippets/quick-shop-modal.liquid).
   ============================================================ */
(function () {
  if (!/search-results-page/.test(location.pathname) && !document.getElementById('snize_results')) return;
  if (document.documentElement.classList.contains('supports-touch')) return;

  var items = {};           /* pid -> {pid, handle, ready, loading, wantOpen, anchor} */
  var active = 0, MAX = 3;  /* concurrent ?view=modal fetches */
  var pending = [];

  function holderOf(it) { return document.getElementById('QuickShopHolder-' + it.handle); }
  function isReady(it) { var h = holderOf(it); return !!(h && h.querySelector('.product-section')); }

  function buildShell(it) {
    if (!document.getElementById('QuickShopModal-' + it.pid)) {
      var shell = document.createElement('div');
      shell.innerHTML = '<div id="QuickShopModal-' + it.pid + '" class="modal modal--square modal--quick-shop dss-qv-from-search" data-product-id="' + it.pid + '">' +
        '<div class="modal__inner"><div class="modal__centered"><div class="modal__centered-content">' +
        '<div id="QuickShopHolder-' + it.handle + '"></div></div>' +
        '<button type="button" class="modal__close js-modal-close text-link">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>' +
        '</button></div></div></div>';
      document.body.appendChild(shell.firstElementChild);
    }
    if (!it.anchor) {
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'dss-qv-anchor js-modal-open-quick-modal-' + it.pid;
      a.setAttribute('aria-hidden', 'true');
      a.tabIndex = -1;
      document.body.appendChild(a);
      it.anchor = a;
    }
  }

  /* CARD PRICE FAST-PATH (25 Aug, Sam: "the formatting takes ages to
     change… stays default, then the theme change kicks in"): the slow
     part was never the CSS (titles are styled the instant cards render)
     but the Ex VAT price decoration, which waits for the Dual Price
     app's catalogue pass (~20 product-JSON fetches). The preloaded
     quick-view content this block already fetches carries every
     variant's price AND taxable flag in its JSON islands — so each
     card's price is decorated the moment its preload lands, correctly:
     cheapest variant (the card shows "From" pricing), single stored
     figure for zero-rated, Ex/Inc split for taxable. dp_catalog marks
     the node so the app's own later pass skips it. */
  function decorateCard(it) {
    var pill = document.querySelector('.dss-snize-qv[data-pid="' + it.pid + '"]');
    var li = pill && pill.closest('li.snize-product');
    var priceEl = li && li.querySelector('.snize-price');
    var deTag = function (el) {   /* strip the app's hook off a finished price: it selects by .dualPrice, so an untagged span can never be blanket-hidden again (26 Aug flashing fix) */
      el.classList.remove('dualPrice');
      if (el.style.display === 'none') el.style.removeProperty('display');
    };
    if (!priceEl) return;
    if (priceEl.classList.contains('dp_catalog')) { deTag(priceEl); return; }
    if (priceEl.querySelector('.firstPrice, .secondPrice')) { deTag(priceEl); return; }   /* app got there first — keep its markup, cut its hide hook */
    var h = document.getElementById('QuickShopHolder-' + it.handle);
    if (!h) return;
    var best = null;
    var islands = h.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < islands.length; i++) {
      var txt = islands[i].textContent;
      if (txt.indexOf('"taxable"') === -1) continue;
      var data;
      try { data = JSON.parse(txt); } catch (e) { continue; }
      var vars = data.variants || (data.currentVariant ? [data.currentVariant] : []);
      for (var j = 0; j < vars.length; j++) {
        if (vars[j] && typeof vars[j].price === 'number' && (!best || vars[j].price < best.price)) best = vars[j];
      }
    }
    if (!best) return;
    var fmt = function (p) {
      try { return window.Shopify.formatMoney(p, window.dp_money_format); } catch (e) { return null; }
    };
    /* deliberately NOT class 'dualPrice': the app blanket-hides every
       .dualPrice span at the start of each of its ~25 passes and re-shows
       them as its fetches resolve — that was the on/off flashing (Sam,
       25 Aug). Card CSS keys on .snize-price/.secondPrice, not .dualPrice,
       so an unmarked span is styled identically and the app never
       touches it. */
    /* discounted card: Searchanise renders the compare-at in its own
       old-price span (.snize-discounted-price — their name for the OLD
       price). Capture it before we rewrite so the decorated markup carries
       the same struck compare-at the app lane emits (.dpCompareAtPrice);
       CSS then hides snize's duplicate. Kept as snize's Inc figure —
       identical basis to the app's collection tiles. */
    var oldEl = li.querySelector('.snize-price-list .snize-discounted-price');
    var oldTxt = oldEl ? oldEl.textContent.replace(/[<>&]/g, '').trim() : '';
    var cap = /\d/.test(oldTxt) ? '<span class="dpCompareAtPrice"><span>' + oldTxt + '</span></span> ' : '';
    if (best.taxable === false) {
      var single = fmt(best.price);
      if (!single) return;
      var zl = window.DSS_DUAL && window.DSS_DUAL.native && window.DSS_DUAL.labels && window.DSS_DUAL.labels.zero;   /* 15 Oct: zero-rated label, native display only */
      priceEl.innerHTML = cap + (zl ? '<span class="secondPrice"><span class="secondPriceValue">' + single + '</span> <span class="secondPriceLabel dss-dp-zerolbl">' + String(zl).replace(/[<>&"]/g, '') + '</span></span>' : single);
      priceEl.classList.add('dp_catalog');
      priceEl.classList.add('nonTaxableVariant');
      return;
    }
    var ex = fmt(Math.round(window.DSS_VAT.ex(best.price))), inc = fmt(Math.round(window.DSS_VAT.inc(best.price)));   /* the one VAT helper (dss_vat_basis) */
    if (!ex || !inc) return;
    var lbl = (window.DSS_DUAL && window.DSS_DUAL.labels) || { ex: 'Ex VAT', inc: 'Inc VAT' };   /* 14 Oct: native-display label settings */
    priceEl.innerHTML = cap +
      '<span class="secondPrice"><span class="secondPriceValue">' + ex + '</span> ' +
      '<span class="secondPriceLabel">' + lbl.ex + '</span></span>' +
      '<span class="firstPrice"><span class="firstPriceValue">' + inc + '</span> ' +
      '<span class="firstPriceLabel">' + lbl.inc + '</span></span>';
    priceEl.classList.add('dp_catalog');
  }

  function finish(it) {
    if (it.ready) return;   /* idempotent: observer + fallback can both call it */
    it.ready = true; it.loading = false; active--;
    document.querySelectorAll('.dss-snize-qv[data-pid="' + it.pid + '"]').forEach(function (p) { p.classList.remove('is-loading'); });
    try { decorateCard(it); } catch (e) {}
    if (it.wantOpen) { it.wantOpen = false; it.anchor.click(); }
    pump();
  }

  function load(it, priority) {
    if (it.ready || it.loading) return;
    if (window.innerWidth <= 768) return;
    if (!priority && active >= MAX) { if (pending.indexOf(it) < 0) pending.push(it); return; }
    it.loading = true; active++;
    buildShell(it);
    var h = holderOf(it);
    if (h && !h.querySelector('.product-section')) h.innerHTML = '';   /* clear a poisoned holder before refetch */
    if (!(window.theme && typeof theme.preloadProductModal === 'function')) { it.loading = false; active--; return; }
    theme.preloadProductModal(it.handle, it.pid, it.anchor);
    /* completion detection is a MutationObserver on the holder, not a
       poll: setTimeout chains are throttled to a crawl in background
       tabs (that is how v4's first validation pass stalled), while
       mutation callbacks fire whenever the DOM actually changes */
    if (it.mo) it.mo.disconnect();
    it.mo = new MutationObserver(function () {
      if (isReady(it)) { it.mo.disconnect(); it.mo = null; finish(it); }
    });
    it.mo.observe(holderOf(it), { childList: true, subtree: true });
    if (isReady(it)) { it.mo.disconnect(); it.mo = null; finish(it); return; }
    setTimeout(function () {   /* fetch died (network error): free the slot; next hover/click refetches */
      if (!it.ready && it.loading) {
        if (it.mo) { it.mo.disconnect(); it.mo = null; }
        it.loading = false; active--; pump();
      }
    }, 25000);
  }

  function pump() {
    while (active < MAX && pending.length) {
      var it = pending.shift();
      if (!it.ready && !it.loading) load(it);
      else if (!pending.length) break;
    }
  }

  function ensurePill(li) {
    var linkEl = li.querySelector('a.snize-view-link');
    var m = linkEl && (linkEl.getAttribute('href') || '').match(/\/products\/([a-z0-9-]+)/);
    var idm = (li.id || '').match(/snize-product-(\d+)/);
    if (!m || !idm) return null;
    var pid = idm[1];
    var it = items[pid] || (items[pid] = { pid: pid, handle: m[1], ready: false, loading: false, wantOpen: false, anchor: null });
    if (!li.querySelector('.dss-snize-qv')) {
      var w = li.querySelector('.snize-thumbnail-wrapper') || li;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dss-snize-qv';
      btn.setAttribute('data-pid', pid);
      btn.textContent = 'Quick view';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (window.innerWidth <= 768) { location.href = '/products/' + it.handle; return; }
        if (it.ready && it.anchor) { it.anchor.click(); return; }
        it.wantOpen = true;
        btn.classList.add('is-loading');
        load(it, true);
        setTimeout(function () {
          if (it.wantOpen && !it.ready) { it.wantOpen = false; location.href = '/products/' + it.handle; }
        }, 6000);
      });
      w.insertBefore(btn, w.firstChild);
      if (it.wantOpen && !it.ready) btn.classList.add('is-loading');
      if (it.ready) { try { decorateCard(it); } catch (e) {} }   /* widget re-render rebuilt the card bare */
    }
    if (!li.__dssQvHover) {
      li.__dssQvHover = true;
      li.addEventListener('mouseenter', function () { load(it, true); });   /* hover jumps the queue */
    }
    return it;
  }

  /* throttled scan: leading edge, then at most every 250ms — immune to
     other apps' mutation storms (the v3 debounce was starved by them) */
  var scanQueued = false, lastScan = 0;
  function scan() {
    lastScan = Date.now();
    var seen = [];
    document.querySelectorAll('#snize_results li.snize-product').forEach(function (li) {
      var it = ensurePill(li);
      if (it) seen.push(it);
    });
    seen.forEach(function (it) { load(it); });   /* preload everything, display order, MAX at a time */
  }
  function requestScan() {
    if (scanQueued) return;
    var since = Date.now() - lastScan;
    if (since >= 250) { scan(); return; }   /* leading edge: a widget re-render is re-pilled and re-priced immediately */
    scanQueued = true;
    setTimeout(function () { scanQueued = false; scan(); }, 250 - since);
  }
  new MutationObserver(requestScan).observe(document.body, { childList: true, subtree: true });
  scan();
})();

/* ============================================================
   HOME HERO SLIDESHOW: autoplay survives manual navigation
   (26 Aug, Sam: "if it goes to the end it stops"). Flickity's
   standard behaviour permanently stops the auto-player the moment
   a visitor clicks an arrow or dot — the SR slider it replaces
   resumed rotating. After each settle, restart the player if the
   section is configured to autoplay (respects reduced-motion via
   the theme's own init, which never starts the player then).
   ============================================================ */
(function () {
  if (!document.body.classList.contains('template-index')) return;
  function arm() {
    var el = document.querySelector('.hero--natural.flickity-enabled');
    if (!el || !window.Flickity) return false;
    var fl = window.Flickity.data(el);
    if (!fl) return false;
    /* LCP handoff: the first slide is CSS-forced visible from first paint
       (no JS needed — see custom.css). After the first rotation, vanilla
       fading takes over for it like any other slide. */
    fl.on('change', function () { el.classList.add('dss-hero-cycled'); });
    if (el.dataset.autoplay !== 'true' || !fl.options.autoPlay) return true;   /* theme skips autoplay for reduced-motion — honour it */
    fl.on('settle', function () {
      if (fl.player && fl.player.state !== 'playing') fl.playPlayer();
    });
    return true;
  }
  if (!arm()) {
    var mo = new MutationObserver(function () { if (arm()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true, attributeFilter: ['class'] });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
})();

/* ============================================================
   "YOU MAY ALSO LIKE" — always a full set (26 Aug, Sam: count varied
   per product; must be 8 every time) + working quick view (26 Aug
   late). The section liquid pads thin recommendation sets from a
   collection (plus one spare, since the CURRENT product can appear
   among the pads — the endpoint context doesn't know which product
   the page is on). Here: drop the current product's tile if present,
   dedupe, and trim to the configured limit. Runs on every injection.
   Optional live overlay for on-machine diagnosis: append
   ?dss-recs-debug=1 to the PDP URL.
   ============================================================ */
(function () {
  var el = document.querySelector('product-recommendations');
  if (!el) return;
  var limit = parseInt(el.dataset.limit, 10) || 8;
  var pid = el.dataset.productId;

  /* v3 (26 Aug late): count ONLY real product tiles. v2 counted every
     .grid__item under the element — but hovering a tile makes the theme
     preload that product's quick-shop modal INTO the tile (the modal
     shell is rendered inside product-grid-item), and the fetched
     ?view=modal product-section carries two bare .grid__item layout
     columns. The first of those has no handle, so the dedupe admitted
     it once — it held a visible slot and the 8th real card went hidden.
     That was Sam's repeatable "8 becomes 7" (hover is in every one of
     his triggers). The "DOM grew 8→12" measured by the earlier session
     was these nested modal columns, not a re-injection wave. */
  function tiles() {
    return [].filter.call(el.querySelectorAll('.grid__item.grid-product'), function (t) {
      return !t.closest('.visually-invisible') && !t.closest('.modal');
    });
  }

  /* v2 lesson kept: NEVER remove nodes. v1 called .remove() from the
     observer, raced the injection, and deleted tiles from the fresh
     set (8→6→4, removal stacks traced). Hiding via a class, recomputed
     in full each pass, is idempotent. */
  function tidy() {
    var list = tiles();
    var reasons = [];
    if (list.length) {
      var shown = 0, seen = {};
      list.forEach(function (t) {
        var h = t.getAttribute('data-product-handle') || '';
        var why = t.getAttribute('data-product-id') === pid ? 'self'
          : seen[h] === 1 ? 'dupe'
          : shown >= limit ? 'cap' : '';
        if (!why) { shown++; seen[h] = 1; }
        else if (dbg) reasons.push(h + ':' + why);
        t.classList.toggle('dss-recs-hide', !!why);
        t.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      });
    }
    dbgStatus(list, reasons);
  }

  /* QUICK VIEW restored (26 Aug late, Sam: "I want it working"). The
     theme's own machinery runs fine on these tiles — the injection path
     calls initQuickShop, hover preloads ?view=modal, theme.Modals binds
     the tile's pill. What broke was the modal's ADDRESS: quick-shop
     shells render inside their tile, i.e. inside product-recommendations,
     where this section's card/grid CSS (grid__item width overrides, AOS
     neutraliser) wrecked the modal's internal layout columns — the raw
     giant-thumbnail modals in Sam's screenshots. The search QV v4 works
     because its shells sit at body level; same medicine here: re-home
     every shell to <body> as soon as it is injected. Shells are moved in
     document order, so the first occurrence of an id keeps winning
     getElementById — padded sets that duplicate a product stay harmless.
     (This also keeps the modal's junk .grid__item columns out of this
     element for good.) */
  function rehomeShells() {
    var moved = 0;
    [].forEach.call(el.querySelectorAll('.modal--quick-shop'), function (shell) {
      if (shell.closest('.visually-invisible')) return;   /* seed grid dies with the placeholder — leave it */
      shell.classList.add('dss-qv-from-recs');   /* styling hook (delivery banner off, as Sam ruled for search QV) */
      document.body.appendChild(shell);
      moved++;
    });
    if (moved) dbgLog('re-homed ' + moved + ' quick-shop shells to body');
  }

  /* ---- debug overlay (?dss-recs-debug=1): DOM truth at a glance —
     counts, per-tile hide reasons, mutation/breakpoint log — so a
     screenshot from Sam's machine tells us removed vs hidden vs never
     injected without a DevTools session. Zero cost when off. ---- */
  var dbg = /[?&#]dss-recs-debug=1/.test(location.search + '#' + location.hash) ? { box: null, log: [], lastVis: -1, status: '(no tidy pass yet)' } : null;
  function dbgPaint() {
    if (!dbg) return;
    if (!dbg.box) {
      dbg.box = document.createElement('div');
      dbg.box.id = 'dss-recs-debug';
      dbg.box.style.cssText = 'position:fixed;left:10px;bottom:10px;z-index:2147483647;background:rgba(10,20,30,.92);color:#d7e3ee;font:11px/1.5 ui-monospace,Menlo,monospace;padding:10px 12px;border-radius:8px;max-width:min(440px,92vw);pointer-events:none;white-space:pre-wrap;';
      document.body.appendChild(dbg.box);
    }
    dbg.box.textContent = dbg.status + (dbg.log.length ? '\n— log —\n' + dbg.log.join('\n') : '');
  }
  function dbgLog(msg) {
    if (!dbg) return;
    var d = new Date(), p = function (n) { return ('0' + n).slice(-2); };
    dbg.log.push(p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds()) + ' ' + msg);
    if (dbg.log.length > 10) dbg.log.shift();
    dbgPaint();   /* breakpoint/mutation lines show immediately, not on the next tidy */
  }
  function dbgStatus(list, reasons) {
    if (!dbg) return;
    var vis = list.filter(function (t) { return !t.classList.contains('dss-recs-hide'); }).length;
    if (dbg.lastVis >= 0 && vis !== dbg.lastVis) dbgLog('VISIBLE ' + dbg.lastVis + ' → ' + vis);
    dbg.lastVis = vis;
    var all = [].filter.call(el.querySelectorAll('.grid__item'), function (t) { return !t.closest('.visually-invisible'); });
    dbg.status =
      'DSS recs debug — theme ' + (window.Shopify && Shopify.theme && Shopify.theme.id) + ' — ' + innerWidth + 'px\n' +
      'tiles:' + list.length + '  visible:' + vis + '  hidden:' + (list.length - vis) +
      '  junk-grid__items:' + (all.length - list.length) +
      '  shells-in-section:' + el.querySelectorAll('.modal--quick-shop').length +
      (reasons.length ? '\nhidden → ' + reasons.join(', ') : '');
    dbgPaint();
  }
  if (dbg) {
    document.addEventListener('matchSmall', function () { dbgLog('breakpoint → mobile (<769px)'); tidy(); });
    document.addEventListener('unmatchSmall', function () { dbgLog('breakpoint → desktop (≥769px)'); tidy(); });
  }

  var tidyTimer = null;
  new MutationObserver(function (muts) {   /* debounced: let each injection finish before recomputing */
    if (dbg) {
      var add = 0, rem = 0;
      muts.forEach(function (m) { add += m.addedNodes.length; rem += m.removedNodes.length; });
      if (add || rem) dbgLog('mutation +' + add + ' −' + rem + ' nodes');
    }
    if (tidyTimer) clearTimeout(tidyTimer);
    tidyTimer = setTimeout(function () { rehomeShells(); tidy(); }, 150);
  }).observe(el, { childList: true, subtree: true });
  rehomeShells();
  tidy();
})();

/* ==========================================================================
   WSS per-unit price widget (markup + CSS: snippets/custom-unit-price.liquid).
   Moved here from the snippet's inline <script> on 10 Sep 2026 so quick views
   on collection and search pages get filled too (their product form arrives as
   injected HTML, whose inline scripts never run). Idempotent, delegated on
   document, keyed on data attributes only. No-op on stores without the widget.
   ========================================================================== */
/* Per-unit price. Idempotent, delegated on document, keyed on data
   attributes only (the quick-view id rewriter renames every id in the
   modal, so ids can never be used for keying). Defined once on window
   and re-run on variant:change, so a quick-view island that was lifted
   into the DOM after this script ran still gets filled. */
(function () {
  if (window.__wssUnitPrice) { window.__wssUnitPrice.init(); return; }

  /* VAT: window.DSS_VAT (the one helper at the top of this file, dss_vat_basis) */

  function money(pence) {
    /* 22 Sep 2026 (Sam): a per-unit price is always shown to the penny, ROUNDED UP, never a fraction of a penny (the
       old 3dp path printed £0.0xx under 10p). Up, not nearest: a quoted unit price must never be lower than what the
       pack actually costs per item. The tiny epsilon stops float noise turning an exact 43p into 44p. */
    var p = Math.ceil(pence - 1e-6) / 100;
    return '£' + p.toFixed(2);
  }

  /* Metafield-only (Sam, 8 Sep 2026): the variant's custom.units_per_pack,
     else the product's. No reading of titles or variant names any more —
     a blank means "not stated", never a guess. The old title parser lives
     on as the one-off audit script _project/multistore/unit-price-audit.py,
     which builds the Matrixify sheet to fill the metafield. */
  function unitsFor(variant, data) {
    var mf = variant && variant.units;
    if (mf === undefined || mf === null || mf === '') mf = data.productUnits;
    var n = parseInt(mf, 10);
    if (n > 1) return { qty: n, noun: 'pack', source: 'metafield' };
    return null;
  }

  function titleCase(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function fill(island) {
    var data;
    try { data = JSON.parse(island.textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.variants.length) return;

    var root = island.previousElementSibling;
    while (root && !root.hasAttribute('data-wss-unit-price')) root = root.previousElementSibling;
    if (!root) {
      var scope = island.parentElement;
      root = scope && scope.querySelector('[data-wss-unit-price]');
    }
    if (!root) return;

    var isCard = root.getAttribute('data-wss-unit-style') === 'card';

    function render(variantId) {
      var variant = null;
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === variantId) { variant = data.variants[i]; break; }
      }
      if (!variant) variant = data.variants[0];

      var pack = unitsFor(variant, data);
      if (!pack || !pack.qty || pack.qty < 2 || !variant.price) { root.hidden = true; syncPackSavings(); return; }

      var zeroRated = variant.taxable === false;
      var exEach = window.DSS_VAT.ex(variant.price, variant.taxable) / pack.qty;
      var incEach = window.DSS_VAT.inc(variant.price, variant.taxable) / pack.qty;
      var noun = pack.noun || 'pack';

      var q = function (sel) { return root.querySelector(sel); };
      var setText = function (sel, text) { var el = q(sel); if (el) el.textContent = text; };

      setText('[data-wss-up-ex]', money(exEach));
      setText('[data-wss-up-exlabel]', zeroRated ? 'each' : 'each Ex VAT');

      var incEl = q('[data-wss-up-inc]');
      if (incEl) {
        if (zeroRated) {
          incEl.hidden = true;
        } else if (root.getAttribute('data-wss-unit-style') === 'panel-table') {
          incEl.textContent = money(incEach);   /* the cell label already says "each, inc VAT" */
          incEl.hidden = false;
        } else {
          incEl.textContent = money(incEach) + ' each Inc VAT';
          incEl.hidden = false;
        }
      }

      if (isCard) {
        setText('[data-wss-up-packcount]', pack.qty);
        setText('[data-wss-up-packnoun]', 'units per ' + noun);
        var minEl = q('[data-wss-up-min]');
        var min = parseInt(data.minimumOrder, 10) || 0;
        /* Ex VAT case price vs the Ex VAT trade minimum */
        var caseEx = window.DSS_VAT.ex(variant.price, variant.taxable) / 100;
        if (minEl && min > 0 && caseEx > 0 && caseEx < min) {
          var n = Math.ceil(min / caseEx);
          var plural = n === 1 ? noun : (/(s|x|ch|sh)$/.test(noun) ? noun + 'es' : noun + 's');
          minEl.textContent = '\u00a3' + min + ' minimum order = ' + n + ' ' + plural + ' (Ex VAT)';
          minEl.hidden = false;
        } else if (minEl) {
          minEl.hidden = true;
        }
      } else {
        /* "Box of 36" when the title names the pack; "Pack of 25" when the
           count came from the metafield or an "x36" title (Sam, 7 Sep:
           "25 units" was ambiguous — "pack" says what the price buys). */
        setText('[data-wss-up-pack]', titleCase(pack.noun || 'pack') + ' of ' + pack.qty);
      }

      root.hidden = false;
      syncPackSavings();
    }

    /* S3 (10 Sep): the legacy title-derived "£X per unit" line
       (custom-pack-savings) must not show while this panel does — it would
       repeat the figure. It records its own decision in data-dss-own; we
       apply "its decision AND panel hidden". */
    function syncPackSavings() {
      var scope = root.closest('[data-product-blocks]') || root.closest('.product-section') || document;
      scope.querySelectorAll('[data-dss-pack-savings]').forEach(function (ps) {
        ps.hidden = ps.dataset.dssOwn !== 'show' || !root.hidden;
      });
    }

    island.__wssRender = render;
    render(data.currentVariantId);
  }

  function init() {
    document.querySelectorAll('[data-wss-unit-price-data]').forEach(function (island) {
      if (island.__wssRender) return;
      fill(island);
    });
  }

  function onVariantChange(event) {
    var variant = event.detail && event.detail.variant;
    init();
    if (!variant) return;
    var origin = event.target && event.target.closest
      ? (event.target.closest('[data-product-blocks]') || event.target.closest('.product-section'))
      : null;
    document.querySelectorAll('[data-wss-unit-price-data]').forEach(function (island) {
      if (!island.__wssRender) return;
      if (origin) {
        var own = island.closest('[data-product-blocks]') || island.closest('.product-section');
        if (own && own !== origin) return;
      }
      island.__wssRender(variant.id);
    });
  }

  window.__wssUnitPrice = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('variant:change', onVariantChange);
  /* Quick view (Sam, 10 Sep): the modal's product form is injected as HTML
     after load, so this inline script never runs again for it and its panel
     stayed hidden. The theme fires modalOpen on every modal open; fill any
     island that has not been filled yet. A MutationObserver would also work
     but this is the cheaper hook and covers the search quick views too. */
  document.addEventListener('modalOpen', function () { setTimeout(init, 0); });
})();

/* ==========================================================================
   DUAL PRICE: STRUCK COMPARE-AT ON THE SAME VAT BASIS AS THE LEAD PRICE
   (WSS launch sweep S1, 10 Sep 2026 — pre-existing on both stores.)

   The Dual Price Display PRO app rebuilds a sale price as:
     <span class="dualPrice"><span class="dpCompareAtPrice">£40.87</span>
       <span class="secondPrice">£30.96 Ex VAT</span>
       <span class="firstPrice">£37.15 Inc VAT</span></span>
   The struck figure is the RAW compare-at (on the STORED basis); the lead line
   is Ex VAT. A shopper reads 24% off when the real discount is 9%. The app
   has no basis option for that line (only show/hide), so the theme rescales
   it: struck = raw × (lead ÷ stored-basis figure), using the figures the app
   itself printed — no VAT-rate assumption, and it follows whichever basis the
   app leads with. 13 Oct 2026 (ex-VAT switch): the stored-basis figure is the
   Inc line on an inc-VAT store and the Ex line on an ex-VAT store
   (DSS_VAT.includes, dss_vat_basis); on an ex store leading Ex the ratio is 1
   and only the label is appended. Zero-rated / NOVAT renders (single figure, no firstPriceValue)
   are left alone: they have no ex/inc split to correct. Re-runs after the
   app's own re-renders (variant change, quick view) via a MutationObserver;
   data-dss-raw remembers the untouched figure so a node is never rescaled
   twice. Applies to the PDP, quick view, collection cards and the sticky
   bar alike — anywhere the app emits .dpCompareAtPrice.
   Container differs per store: WSS keeps the theme span and gets a
   .dualPrice wrapper inside it; DSS's block is replaced outright and the
   figures sit directly in .product-block--price.dp_detail.
   ========================================================================== */
(function () {
  'use strict';
  var num = function (s) { return parseFloat(String(s || '').replace(/[^\d.]/g, '')); };
  /* 14 Sep sweep W-S1/D-S16: the app's figures carry thousands separators
     (£1,706.40); the struck figure we recompute must too, or a pallet tile
     shows £1922.40 beside £1,706.40. */
  var fmt = function (n) { return '£' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

  function fixCompare(root) {
    /* WSS: the app wraps the theme's span in .dualPrice; DSS: it replaces the
       whole price block, which then carries .dp_detail (or .dp_catalog on
       cards) with no .dualPrice inside. Start from the struck element and
       take whichever container holds the two figures. */
    (root || document).querySelectorAll('.dpCompareAtPrice').forEach(function (cmp) {
      var dual = cmp.closest('.dualPrice, .dp_detail, .dp_catalog') || cmp.parentElement;
      if (!dual) return;
      var inner = cmp.querySelector('span') || cmp;
      if (inner.dataset.dssRaw) return;                       // already rescaled
      var raw = num(inner.textContent);
      /* 13 Oct: mark the node as seen BEFORE any early return — custom.css hides every compare-at that carries no
         data-dss-raw (so the app's later re-renders can never flash the raw inc-VAT figure), which means a figure we
         decide NOT to rescale must still be marked or it would stay hidden. */
      if (raw > 0) { inner.dataset.dssRaw = raw; settled(); }
      var lead = dual.querySelector('.secondPrice, .firstPrice');
      var inc = dual.querySelector('.firstPriceValue');
      if (!lead || !inc) return;                              // single-figure render: nothing to correct
      var leadVal = num((lead.querySelector('.secondPriceValue, .firstPriceValue') || lead).textContent);
      var incVal = num(inc.textContent);
      if (!(raw > 0 && incVal > 0 && leadVal > 0)) return;
      var labelEl = lead.querySelector('.secondPriceLabel, .firstPriceLabel');
      if (window.DSS_VAT && window.DSS_VAT.includes === false) {
        /* ex-VAT storage: the raw compare-at is on the Ex basis */
        var exEl = dual.querySelector('.secondPriceValue');
        var exVal = exEl ? num(exEl.textContent) : 0;
        if (!(exVal > 0)) return;
        inner.textContent = fmt(raw * (leadVal / exVal)) + (labelEl ? ' ' + labelEl.textContent.trim() : '');
        return;
      }
      var ratio = leadVal / incVal;
      if (ratio >= 0.999) return;                             // lead is already the inc figure
      inner.textContent = fmt(raw * ratio) + (labelEl ? ' ' + labelEl.textContent.trim() : '');
    });
  }

  /* 9 Oct 2026 (Sam: "why does the strike-through price flicker so much"):
     measured on the 450ml milk mug, the struck figure changed three times in
     the first second — the theme's £3.11, the app's rebuild of the block, then
     this rescale to £2.59 Ex VAT. So html.dss-price-pending hides the struck
     figure (custom.css) from first paint until the rescale has run once, or
     2.5 s if the app never renders (no-sale pages and app outages still show
     the theme's own figure). */
  var settledOnce = false;
  function settled() {
    if (settledOnce) return;
    settledOnce = true;
    document.documentElement.classList.remove('dss-price-pending');
  }
  /* the class itself is set by an inline script in theme.liquid so it is there at first paint (custom.js is deferred) */
  setTimeout(settled, 2500);

  var pending = null;
  function schedule() {
    fixCompare();                                             // 13 Oct: synchronous — the app's re-render and our rescale land in the same frame (the 40 ms wait let the raw figure flash for 50–90 ms)
    if (pending) return;
    pending = setTimeout(function () { pending = null; fixCompare(); }, 40);
  }
  function start() {
    fixCompare();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('variant:change', function () { setTimeout(fixCompare, 300); setTimeout(fixCompare, 1200); });
    document.addEventListener('modalOpen', function () { setTimeout(fixCompare, 300); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ==========================================================================
   JUDGE.ME PREVIEW BADGE → REVIEWS: land with the tab strip visible
   (DSS, 10 Sep 2026 — Sam: "clicking the star rating overshoots; probably
   the nav bar being in the way").

   Judge.me scrolls the reviews widget to `jdgmSettings.scrollTopOffset` px
   from the top of the viewport (30 by default). On DSS the header and the
   nav bar are fixed once the page has scrolled (117 + 50 px), and the widget
   sits 67 px below the Smart Tabs strip, so the strip and the top of the
   widget ended up underneath the nav. Before Judge.me's own click handler
   runs (capture phase), set the offset to: the sticky stack's height + the
   distance from the tab strip to the widget + a little air. Inert on a
   store without the badge (WSS).
   ========================================================================== */
(function () {
  'use strict';
  function stackHeight() {
    var h = 0;
    var hdr = document.getElementById('SiteHeader');
    if (hdr) h += hdr.getBoundingClientRect().height;
    var bar = document.querySelector('.toolbar.dss-nav-ready, .toolbar');
    if (bar && window.innerWidth > 768) h += bar.getBoundingClientRect().height;
    return Math.round(h);
  }
  /* Measured 10 Sep: Judge.me scrolls first, then the tabs app scrolls again
     to its own idea of the tab's top (scrollY 769 → 1622 → 1443) and re-asserts
     it if anything moves the page afterwards, so correcting the scroll is a
     fight we lose. Where it lands, the tab strip sits 24px below the fixed
     header — fine — unless the nav bar is showing (html.dss-up), which then
     covers it. So: once both apps have settled, if the bar is over the strip,
     tuck the bar away exactly as a downward scroll does (drop dss-up); the
     next upward scroll brings it back as usual. */
  document.addEventListener('click', function (e) {
    var badge = e.target && e.target.closest && e.target.closest('.jdgm-prev-badge, .jdgm-preview-badge');
    if (!badge) return;
    var widget = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
    if (!widget) return;
    var started = Date.now(), lastY = window.scrollY, stableSince = Date.now();
    (function settle() {
      var y = window.scrollY;
      if (y !== lastY) { lastY = y; stableSince = Date.now(); }
      if (Date.now() - stableSince < 300 && Date.now() - started < 3000) { setTimeout(settle, 50); return; }
      var strip = widget.closest('[class*="smart-tabs"]') ? document.querySelector('[class*="smart-tabs-navigation"]') : null;
      var target = strip || widget;
      function tuck() {
        var bar = document.querySelector('.toolbar');
        var hdr = document.getElementById('SiteHeader');
        var root = document.documentElement;
        if (!bar || !hdr || getComputedStyle(bar).position !== 'fixed') return;
        /* judge by the INTENDED state (html.dss-up = bar shown or sliding in),
           not the bar's mid-animation position */
        var willShow = root.classList.contains('dss-up');
        var stackBottom = hdr.getBoundingClientRect().bottom + bar.getBoundingClientRect().height;
        if (willShow && target.getBoundingClientRect().top < stackBottom + 4) root.classList.remove('dss-up');
      }
      tuck(); setTimeout(tuck, 700); setTimeout(tuck, 1500);
    })();
  }, true);
})();

/* ==========================================================================
   CART RECOMMENDATIONS — <dss-cart-recs> (10 Sep 2026)
   "Customers also bought" in the cart drawer and on the cart page, from
   Shopify's own Product Recommendations endpoint. Markup and the design
   note: sections/custom-cart-recommendations.liquid.

   Lifecycle
   - Drawer: fetch on drawerOpen.CartDrawer (never on page load). Cart page:
     fetch when the block scrolls near the viewport (IntersectionObserver).
   - Refetch, debounced 400ms, on the theme's cart events (cart:updated with
     the cart JSON, ajaxProduct:added, cart:build). A cart signature (line
     keys + quantities + source) skips a refetch when nothing changed; an
     AbortController cancels a request the cart has already outrun.
   - Source product: newest line (Shopify's cart.js lists items newest first)
     or the highest-value line, per setting. Limit sent = wanted + lines in
     the cart (capped at 10) so the Liquid filter, which drops products
     already in the basket, still has enough to show.
   - Nothing renders until results arrive; zero cards = the whole block stays
     hidden. The drawer mount sits below the line items, so the checkout
     button never moves.
   - Quick add (single-variant products only): POST /cart/add.js, then the
     theme's own ajaxProduct:added, so the drawer rebuilds exactly as it does
     for any other add; the block then refreshes with the new line as source.
   ========================================================================== */
(function () {
  'use strict';
  if (window.customElements && !customElements.get('dss-cart-recs')) {
    class DssCartRecs extends HTMLElement {
      connectedCallback() {
        this.base = this.dataset.url || '/recommendations/products';
        this.sid = this.dataset.sectionId;
        this.limit = Math.max(1, parseInt(this.dataset.limit, 10) || 4);
        this.intent = this.dataset.intent || 'related';
        this.source = this.dataset.source || 'newest';
        this.context = this.dataset.context || 'drawer';
        this.grid = this.querySelector('[data-dss-recs-grid]');
        this.sig = null; this.ctrl = null; this.timer = null; this.dirty = true; this.armed = false;
        if (!this.grid) return;

        var self = this;
        var onCart = function () { self.dirty = true; self.schedule(400); };
        ['cart:updated', 'ajaxProduct:added', 'cart:build'].forEach(function (ev) { document.addEventListener(ev, onCart); });

        if (this.context === 'drawer') {
          document.addEventListener('drawerOpen.CartDrawer', function () { self.armed = true; self.schedule(0); });
          if (document.documentElement.classList.contains('js-drawer-open')) { this.armed = true; this.schedule(0); }
        } else if ('IntersectionObserver' in window) {
          /* observe the element itself (it is NOT hidden on the page — a hidden
             element has no box and never intersects); its wrapper as a fallback */
          if (this.hidden) this.hidden = false;
          var io = new IntersectionObserver(function (entries) {
            if (entries.some(function (e) { return e.isIntersecting; })) { self.armed = true; self.schedule(0); io.disconnect(); }
          }, { rootMargin: '240px 0px' });
          io.observe(this.parentElement || this);
        } else { this.armed = true; this.schedule(0); }

        /* swipe-row arrows (mouse users): step one tile; state from the grid's scroll */
        this.nav = this.querySelector('[data-dss-recs-nav]');
        this.initDrag();
        if (this.nav) {
          this.grid.addEventListener('scroll', function () { self.updateNav(); }, { passive: true });
          window.addEventListener('resize', function () { self.updateNav(); });
        }
        this.addEventListener('click', function (e) {
          var arrow = e.target && e.target.closest && e.target.closest('[data-dss-recs-prev], [data-dss-recs-next]');
          if (arrow) { e.preventDefault(); self.step(arrow.hasAttribute('data-dss-recs-next') ? 1 : -1); return; }
          var btn = e.target && e.target.closest && e.target.closest('[data-dss-recs-add]');
          if (btn) { e.preventDefault(); self.quickAdd(btn); return; }
          var qv = e.target && e.target.closest && e.target.closest('[data-dss-recs-qv]');
          if (qv) self.quickView(qv, e);
        });
        /* desktop: preload a product's quick view on first hover, like the theme's grid does */
        this.addEventListener('mouseover', function (e) {
          var item = e.target && e.target.closest && e.target.closest('.dss-recs__item');
          var qv = item && item.querySelector('[data-dss-recs-qv]');
          if (qv && !qv.dataset.dssPreloaded && !self.phone()) { qv.dataset.dssPreloaded = '1'; self.preload(qv); }
        });
      }

      schedule(ms) {
        var self = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () { self.refresh(); }, ms);
      }

      drawerOpen() { return document.documentElement.classList.contains('js-drawer-open'); }

      refresh() {
        var self = this;
        if (!this.armed) return;
        if (this.context === 'drawer' && !this.drawerOpen()) return;   /* stays dirty; the next open refetches */
        if (!this.dirty && this.sig !== null) return;
        fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var items = cart && cart.items ? cart.items : [];
            if (!items.length) { self.sig = 'empty'; self.dirty = false; self.hide(); return; }
            var sig = self.source + '|' + items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
            if (sig === self.sig) { self.dirty = false; return; }
            var src = items[0];
            if (self.source === 'value') src = items.slice().sort(function (a, b) { return b.final_line_price - a.final_line_price; })[0];
            var limit = Math.min(10, self.limit + items.length);
            var url = self.base + '?section_id=' + encodeURIComponent(self.sid) + '&product_id=' + src.product_id + '&intent=' + self.intent + '&limit=' + limit;
            if (self.ctrl) self.ctrl.abort();
            self.ctrl = new AbortController();
            return fetch(url, { signal: self.ctrl.signal, credentials: 'same-origin' })
              .then(function (r) { return r.ok ? r.text() : ''; })
              .then(function (html) {
                self.sig = sig; self.dirty = false;
                var doc = new DOMParser().parseFromString(html || '', 'text/html');
                var grid = doc.querySelector('[data-dss-recs-grid]');
                var count = grid ? parseInt(grid.dataset.count, 10) || 0 : 0;
                if (!count) { self.hide(); return; }
                self.grid.innerHTML = grid.innerHTML;
                self.grid.dataset.count = count;
                self.grid.querySelectorAll('a, img').forEach(function (n) { n.setAttribute('draggable', 'false'); });
                self.adoptModalShells(doc);
                if (window.theme && typeof theme.reinitProductGridItem === 'function') { try { theme.reinitProductGridItem(self); } catch (e) {} }
                self.show();
              });
          })
          .catch(function (err) { if (!err || err.name !== 'AbortError') self.hide(); });
      }

      /* click-and-drag on the swipe row (mouse). Pointer events, mouse only —
         touch scrolls natively. A drag past 6px swallows the click that would
         otherwise open the quick view or add the product; snap is off while
         dragging and back on release so the row settles on a tile. */
      initDrag() {
        var g = this.grid, self = this;
        if (!g || !window.PointerEvent) return;
        var down = null, moved = false;
        /* links and images are draggable by default — a drag that starts on a
           product image became a ghost-image drag instead of a scroll */
        g.addEventListener('dragstart', function (e) { e.preventDefault(); });
        g.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0 || !self.classList.contains('dss-recs--row')) return;
          if (g.scrollWidth <= g.clientWidth + 2) return;
          down = { x: e.clientX, left: g.scrollLeft, id: e.pointerId }; moved = false;
        });
        g.addEventListener('pointermove', function (e) {
          if (!down || e.pointerId !== down.id) return;
          var dx = e.clientX - down.x;
          if (!moved && Math.abs(dx) > 6) { moved = true; g.classList.add('is-dragging'); try { g.setPointerCapture(down.id); } catch (err) {} }
          if (moved) { g.scrollLeft = down.left - dx; e.preventDefault(); }
        });
        var end = function (e) {
          if (!down) return;
          if (moved) {
            g.classList.remove('is-dragging');
            try { g.releasePointerCapture(down.id); } catch (err) {}
            var block = function (ev) { ev.stopPropagation(); ev.preventDefault(); g.removeEventListener('click', block, true); };
            g.addEventListener('click', block, true);
            setTimeout(function () { g.removeEventListener('click', block, true); }, 0);
          }
          down = null; moved = false;
        };
        g.addEventListener('pointerup', end);
        g.addEventListener('pointercancel', end);
        g.addEventListener('lostpointercapture', end);
      }
      step(dir) {
        var tile = this.grid.querySelector('.dss-recs__item');
        var w = tile ? tile.getBoundingClientRect().width + 12 : this.grid.clientWidth / 2;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.grid.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
      }
      updateNav() {
        if (!this.nav) return;
        var g = this.grid, overflow = g.scrollWidth > g.clientWidth + 2;
        this.nav.hidden = !overflow || this.hidden;
        if (!overflow) return;
        var prev = this.nav.querySelector('[data-dss-recs-prev]'), next = this.nav.querySelector('[data-dss-recs-next]');
        prev.disabled = g.scrollLeft <= 2;
        next.disabled = g.scrollLeft + g.clientWidth >= g.scrollWidth - 2;
      }
      show() {
        this.hidden = false; this.classList.add('is-loaded');
        var self = this; requestAnimationFrame(function () { self.updateNav(); });
        if (window.AOS && AOS.refreshHard) AOS.refreshHard();
      }

      hide() { this.hidden = true; this.classList.remove('is-loaded'); this.grid.innerHTML = ''; }

      /* QUICK VIEW for multi-variant products (Sam, 10 Sep: open the quick view
         so pack size / colour can be chosen and added; the theme then opens the
         drawer). The endpoint response carries a quick-shop-modal shell per
         multi-variant card in <template data-dss-recs-modals>; shells are moved
         to <body> (a fixed modal inside the drawer's transform would be trapped)
         and de-duplicated by id. theme.preloadProductModal fetches the product
         form into the shell and binds every element carrying
         .js-modal-open-quick-modal-<id> — our button — via theme.Modals. */
      adoptModalShells(doc) {
        var tpl = doc.querySelector('template[data-dss-recs-modals]');
        if (!tpl) return;
        var frag = document.importNode(tpl.content, true);
        frag.querySelectorAll('.modal--quick-shop').forEach(function (shell) {
          if (!document.getElementById(shell.id)) document.body.appendChild(shell);
        });
      }
      shellReady(pid, handle) {
        var holder = document.getElementById('QuickShopHolder-' + handle);
        return !!(holder && holder.querySelector('.product-section'));
      }
      preload(btn) {
        var pid = btn.dataset.dssRecsQv, handle = btn.dataset.handle;
        if (!pid || !handle || !(window.theme && typeof theme.preloadProductModal === 'function')) return;
        if (this.shellReady(pid, handle)) { this.bind(btn); return; }
        if (!document.getElementById('QuickShopModal-' + pid)) return;
        theme.preloadProductModal(handle, pid, btn);   /* binds triggers (incl. this button) when the form lands */
        btn.dataset.dssBound = '1';
      }
      bind(btn) {
        /* form already loaded (an earlier render bound the OLD button): bind this one */
        if (btn.dataset.dssBound) return;
        var pid = btn.dataset.dssRecsQv;
        try { new theme.Modals('QuickShopModal-' + pid, 'quick-modal-' + pid); btn.dataset.dssBound = '1'; } catch (e) {}
      }
      /* Phones: no quick view — the theme never offers it below 769px (its own
         quick-shop buttons are small--hide) and the modal is the whole product
         page in a box. "Choose options" is a plain link there (Sam, 10 Sep). */
      phone() { return window.matchMedia && window.matchMedia('(max-width: 768px)').matches; }
      quickView(btn, e) {
        if (this.phone()) return;   /* the link navigates */
        var pid = btn.dataset.dssRecsQv, handle = btn.dataset.handle;
        if (!(window.theme && typeof theme.preloadProductModal === 'function') || !document.getElementById('QuickShopModal-' + pid)) return;   /* fall through to the product page */
        if (btn.dataset.dssBound && this.shellReady(pid, handle)) return;   /* theme.Modals handles this click */
        e.preventDefault();
        if (this.shellReady(pid, handle)) { this.bind(btn); btn.click(); return; }
        btn.classList.add('is-loading');
        var self = this, holder = document.getElementById('QuickShopHolder-' + handle);
        this.preload(btn);
        var done = false, t0 = Date.now();
        var mo = new MutationObserver(function () {
          if (done || !self.shellReady(pid, handle)) return;
          done = true; mo.disconnect(); btn.classList.remove('is-loading');
          setTimeout(function () { btn.click(); }, 30);   /* now bound by theme.Modals */
        });
        if (holder) mo.observe(holder, { childList: true, subtree: true });
        setTimeout(function () { if (!done) { done = true; mo.disconnect(); btn.classList.remove('is-loading'); window.location.href = btn.getAttribute('href'); } }, 8000);
      }

      quickAdd(btn) {
        var id = parseInt(btn.dataset.dssRecsAdd, 10);
        if (!id || btn.disabled) return;
        var label = btn.querySelector('.dss-recs__add-label') || btn;
        var original = label.textContent;
        btn.disabled = true; btn.classList.add('is-adding'); label.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            label.textContent = 'Added';
            btn.classList.remove('is-adding'); btn.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));   /* theme: rebuild + open drawer */
          })
          .catch(function () {
            btn.disabled = false; btn.classList.remove('is-adding'); label.textContent = original;
            var link = btn.closest('.dss-recs__item') && btn.closest('.dss-recs__item').querySelector('.grid-product__link');
            if (link) window.location.href = link.getAttribute('href');
          });
      }
    }
    customElements.define('dss-cart-recs', DssCartRecs);
  }
})();

/* ==========================================================================
   CART DRAWER ORDER NOTE — toggle (10 Sep 2026). Markup: the DSS HOOK in
   snippets/cart-drawer.liquid. Opens the textarea, focuses it, and flips the
   label to "Order note"; the drawer's line-item rebuild does not touch this
   block, so state survives cart changes.
   ========================================================================== */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-dss-note-toggle]');
    if (!t) return;
    var wrap = t.closest('[data-dss-note]');
    var open = !wrap.classList.contains('is-open');
    wrap.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    var lbl = t.querySelector('.dss-note__label');
    var ta = wrap.querySelector('textarea');
    if (lbl) lbl.textContent = open || (ta && ta.value.trim()) ? 'Order note' : 'Add an order note';
    if (open && ta) setTimeout(function () { ta.focus(); }, 60);
  });
})();

/* --------------------------------------------------------------------------
   PDP gallery — ↑ / ↓ move through the photos (Sam, 17 Sep 2026). The
   thumbnails run vertically beside the main photo on desktop, so up/down is
   the natural pair (Flickity already handles ← / → when the slider itself has
   focus). Only while the gallery is in play — a thumbnail or the slider has
   keyboard focus, or the pointer is over the gallery — so the arrows keep
   scrolling the page everywhere else. Wraps at either end like the slider.
   -------------------------------------------------------------------------- */
(function () {
  var hovered = null;
  document.addEventListener('pointerover', function (e) { hovered = e.target.closest ? e.target.closest('.product__photos') : null; }, true);
  document.addEventListener('pointerleave', function (e) { if (e.target === hovered) hovered = null; }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
    if (e.altKey || e.ctrlKey || e.metaKey) return;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return;
    // never while something sits on top of the page: the reviews / points dialogs, the zoom lightbox, a theme modal
    // or an open drawer — the arrows belong to that layer, or to page scrolling inside it (board 3 engineering, 18 Sep)
    if (document.querySelector('dialog[open], .pswp--open, .modal--is-active, .drawer--is-open')) return;
    var gallery = (a && a.closest && a.closest('.product__photos')) || hovered;
    if (!gallery || gallery.closest('.modal--quick-shop')) return;
    var el = gallery.querySelector('[data-product-photos]');
    var fk = window.Flickity && el ? window.Flickity.data(el) : null;
    if (!fk) return;
    e.preventDefault();
    if (e.key === 'ArrowDown') fk.next(true); else fk.previous(true);
    // the theme blurs every thumbnail on a slide change, which would drop focus
    // to the page after one press — hand it to the thumbnail that is now active
    var active = a && gallery.contains(a) && gallery.querySelector('.product__thumb.is-active');
    if (active) active.focus({ preventScroll: true });
  });
})();

/* --------------------------------------------------------------------------
   Sold-out help: "See similar items ↓" jumps to the page's own "You may also
   like" section (Sam, 18 Sep 2026). The section lazy-loads when it nears the
   viewport, so the scroll itself brings the tiles in; focus lands on its
   heading for keyboard and screen-reader users. No recommendations on the page
   (or an empty set) → the link's href, the product's collection filtered to
   in-stock, is followed instead.
   -------------------------------------------------------------------------- */
document.addEventListener('click', function (e) {
  var link = e.target.closest && e.target.closest('[data-dss-similar]');
  if (!link) return;
  var recs = document.querySelector('product-recommendations, [data-section-type="product-recommendations"]');
  if (!recs) return;
  var loaded = recs.querySelector('.grid-product');
  var pending = recs.querySelector('.product-recommendations-placeholder') || !recs.children.length;
  if (!loaded && !pending) return;                       // rendered and empty → follow the href
  e.preventDefault();
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  recs.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  setTimeout(function () {
    var h = recs.querySelector('h2, h3, .section-header__title');
    if (!h) return;
    if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
    try { h.focus({ preventScroll: true }); } catch (err) {}
  }, reduce ? 0 : 700);
});

/* ============================================================
   GANG SHEETS IN THE BASKET → the whole order works to 12 noon (22 Sep 2026)
   The delivery row is rendered with data-dss-gang-in-cart from Liquid at page load. When the basket changes without a
   reload (the theme's ajax add / drawer), /cart.js is read and each line's product is checked for the Gang_Sheet tag via
   /products/<handle>.js (cached per handle), the attribute is updated and the row re-rendered. Also feeds the cart note
   (data-dss-gang-note) in the drawer and on the cart page.
   ============================================================ */
(function () {
  var tagCache = {};
  var hasGang = function (handle) {
    if (handle in tagCache) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      var yes = !!(p && p.tags && p.tags.some(function (t) { return String(t).toLowerCase() === 'gang_sheet'; }));
      tagCache[handle] = yes; return yes;
    }).catch(function () { return false; });
  };
  var check = function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var handles = []; (cart.items || []).forEach(function (i) { if (i.handle && handles.indexOf(i.handle) < 0) handles.push(i.handle); });
      return Promise.all(handles.map(hasGang)).then(function (flags) { return flags.some(Boolean); });
    }).then(function (inCart) {
      document.querySelectorAll('[data-dss-delivery]').forEach(function (row) {
        if (row.getAttribute('data-dss-gang-in-cart') !== String(inCart)) { row.setAttribute('data-dss-gang-in-cart', String(inCart)); if (window.dssRenderDelivery) window.dssRenderDelivery(); }
      });
      document.querySelectorAll('[data-dss-gang-note]').forEach(function (n) { n.hidden = !inCart; });
    }).catch(function () {});
  };
  ['cart:updated', 'ajaxProduct:added', 'cart:build'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(check, 400); }, true); });
})();


/* ============================================================
   THEME BADGES (9 Oct 2026; rebuilt 9 Oct pm as full-colour discs on the photo; REVISED 9 Oct evening to the four
   reviews in _project/design-reviews/2026-10-09-badges/) — markup: snippets/custom-badges.liquid, CSS: the >>> BADGES
   block in custom.css.
   1. Tooltip: one shared white card (T1, 9 Oct 2026: the name; the description as a second line only when non-blank). Mouse: on hover, and it stays while the pointer is on the box
      itself (150ms grace). Keyboard: on focus, positioned a frame later so it lands where the browser scrolled the disc
      to. Touch: a tap toggles it (auto-hides after 6s; a tap elsewhere / any scroll / Esc hides it). Any scroll hides it.
   2. Clicks: a MOUSE click on a card disc (decorative span over the photo) falls through to the card's link, with the
      modifier keys, so the disc never dead-ends a click; a touch tap on any disc only toggles the tooltip and never
      follows the link. Product-page overlay discs are buttons (keyboard path) when the row is not shown.
   3. Variant switching: when variants carry their own badge lists the snippet prints a JSON map
      {"d": <product-level row>, "<variant id>": <row>}. On the theme's container-level `variantChange` (capture, scoped
      to the section that changed — a quick-view change never touches the page behind it) every row in the section
      (gallery copy + the phone copy under the price) is swapped synchronously and the gallery overlay is rebuilt from
      it with the snippet's rules: buttons when the row is hidden (fewer badges than data-dss-max, row mode extra),
      decorative spans when the row shows.
   4. Preview (staging only): ?badges=preview shows every Badge entry as if assigned, from the hidden
      <template data-dss-badges-preview> the snippet prints on UNPUBLISHED themes only. Remembered for the tab;
      ?badges=off clears it. No product data is touched.
   ============================================================ */
(function () {
  var SEL = '[data-dss-badge-name]';
  var tip = null, openEl = null, hideT = null, hoverEl = null, graceT = null;
  var fine = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: true };

  function ensureTip() {
    if (tip) return tip;
    tip = document.createElement('div');
    tip.className = 'dss-badge-tip';
    tip.id = 'dss-badge-tip';
    tip.setAttribute('role', 'tooltip');
    tip.addEventListener('mouseenter', function () { clearTimeout(graceT); });
    tip.addEventListener('mouseleave', function (e) {
      if (openEl) return;
      if (hoverEl && e.relatedTarget && hoverEl.contains(e.relatedTarget)) return;
      hide();
    });
    document.body.appendChild(tip);
    return tip;
  }
  function show(el) {
    var t = ensureTip();
    var name = el.getAttribute('data-dss-badge-name') || '', desc = (el.getAttribute('data-dss-badge-desc') || '').trim();
    t.innerHTML = '';
    var b = document.createElement('b'); b.textContent = name; t.appendChild(b);
    if (desc) { var d = document.createElement('span'); d.textContent = desc; t.appendChild(d); }   /* second line only when the entry has a description (T1) */
    t.className = 'dss-badge-tip';
    var r = el.getBoundingClientRect(), tw = t.offsetWidth, th = t.offsetHeight, vw = document.documentElement.clientWidth;
    var x = Math.max(8, Math.min(r.left + r.width / 2 - tw / 2, vw - tw - 8));
    var above = r.top - th - 10 > 8;
    t.style.left = x + 'px';
    t.style.top = (above ? r.top - th - 10 : r.bottom + 10) + 'px';
    t.style.setProperty('--ax', Math.max(12, Math.min(tw - 12, r.left + r.width / 2 - x)) + 'px');
    t.className = 'dss-badge-tip is-on ' + (above ? 'is-above' : 'is-below');
    if (el.tagName === 'BUTTON') el.setAttribute('aria-describedby', 'dss-badge-tip');
  }
  function hide() {
    clearTimeout(hideT); clearTimeout(graceT);
    if (tip) tip.className = 'dss-badge-tip';
    document.querySelectorAll('.is-open' + SEL + ', [aria-describedby="dss-badge-tip"]').forEach(function (b) {
      b.classList.remove('is-open'); b.removeAttribute('aria-describedby');
    });
    openEl = null; hoverEl = null;
  }

  document.addEventListener('mouseover', function (e) {
    if (!fine.matches || openEl) return;
    var b = e.target.closest && e.target.closest(SEL);
    if (!b) return;
    if (b === hoverEl) { clearTimeout(graceT); return; }
    hoverEl = b; show(b);
  });
  document.addEventListener('mouseout', function (e) {
    if (!fine.matches || openEl || !hoverEl) return;
    var b = e.target.closest && e.target.closest(SEL);
    if (!b || (e.relatedTarget && (b.contains(e.relatedTarget) || (tip && tip.contains(e.relatedTarget))))) return;
    clearTimeout(graceT);
    graceT = setTimeout(hide, 150);                          /* grace: the pointer may be on its way to the tooltip */
  });
  document.addEventListener('focusin', function (e) {
    var b = e.target.closest && e.target.closest(SEL);
    if (!b) return;
    requestAnimationFrame(function () { if (document.activeElement === b) show(b); });   /* after scroll-into-view */
  });
  document.addEventListener('focusout', function (e) {
    if (openEl) return;
    if (e.target.closest && e.target.closest(SEL)) hide();
  });
  /* capture phase: a touch tap on a disc toggles the tooltip and goes no further; a mouse click on a card disc becomes
     a click on the card link (the disc sits over the link's hit layer) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(SEL);
    if (!b) { if (openEl) hide(); return; }
    if (fine.matches && e.detail > 0) {                      /* mouse: the hover tooltip is already showing */
      var card = b.closest('.dss-badges-card');
      if (!card) return;
      var host = card.closest('.grid-product__content, .grid-product, .grid__item');
      var link = host && host.querySelector('a.grid-product__link');
      if (!link) return;
      e.preventDefault(); e.stopPropagation();
      var ev;
      try {
        ev = new MouseEvent('click', { bubbles: true, cancelable: true, view: window, button: e.button,
          ctrlKey: e.ctrlKey, metaKey: e.metaKey, shiftKey: e.shiftKey, altKey: e.altKey });
      } catch (err) { ev = null; }
      if (ev) link.dispatchEvent(ev); else link.click();
      return;
    }
    e.preventDefault(); e.stopPropagation();
    if (openEl === b) { hide(); return; }
    hide(); openEl = b; b.classList.add('is-open'); show(b);
    hideT = setTimeout(hide, 6000);
  }, true);
  ['touchstart', 'pointerdown'].forEach(function (ev) {    /* some themes act on press, not click */
    document.addEventListener(ev, function (e) {
      if (fine.matches && e.pointerType !== 'touch' && ev === 'pointerdown') return;
      if (e.target.closest && e.target.closest(SEL)) e.stopPropagation();
    }, { capture: true, passive: true });
  });
  window.addEventListener('scroll', function () { if (tip && tip.classList.contains('is-on')) hide(); }, { passive: true });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && tip && tip.classList.contains('is-on')) hide(); });

  /* ---- product page: rebuild the overlay from the row, swap every row in the section ---- */
  function rows(section) { return section ? section.querySelectorAll('[data-dss-badges-row]') : []; }
  function syncFromRow(wrap) {
    var row = wrap.querySelector('[data-dss-badges-row]');
    var over = wrap.querySelector('[data-dss-badges-over]');
    var items = row ? row.querySelectorAll('.dss-badge-item') : [];
    var max = parseInt(wrap.getAttribute('data-dss-max') || '2', 10), mode = wrap.getAttribute('data-dss-row') || 'extra';
    var rowOn = (mode === 'always' && items.length > 0) || (mode === 'extra' && items.length > max);
    if (rowOn) wrap.setAttribute('data-row-on', ''); else wrap.removeAttribute('data-row-on');
    if (over) {
      over.innerHTML = '';
      for (var i = 0; i < items.length && i < max; i++) {
        var src = items[i].querySelector('.dss-badge');
        if (!src) continue;
        var el = document.createElement(rowOn ? 'span' : 'button');
        if (!rowOn) { el.type = 'button'; el.setAttribute('aria-label', items[i].getAttribute('data-dss-badge-name') || ''); }
        else el.setAttribute('aria-hidden', 'true');
        el.className = src.className;
        ['data-dss-badge-name', 'data-dss-badge-desc'].forEach(function (a) { var v = items[i].getAttribute(a); if (v !== null) el.setAttribute(a, v); });
        if (src.getAttribute('style')) el.setAttribute('style', src.getAttribute('style'));
        el.innerHTML = src.innerHTML;
        over.appendChild(el);
      }
    }
    if (items.length) wrap.removeAttribute('data-empty'); else wrap.setAttribute('data-empty', '');
  }
  function setRows(section, wrap, html) {
    rows(section).forEach(function (r) { r.innerHTML = html; });
    syncFromRow(wrap);
  }

  document.addEventListener('variantChange', function (event) {
    var v = event.detail && event.detail.variant;
    if (!v) return;
    var section = event.target && event.target.closest ? (event.target.closest('.product-section') || event.target) : null;
    if (!section || !section.querySelector) return;
    var wrap = section.querySelector('[data-dss-badges]');
    if (!wrap || wrap.hasAttribute('data-dss-badges-previewing')) return;
    var mapEl = wrap.querySelector('[data-dss-badges-map]');
    if (!mapEl) return;
    var map = {}; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    var html = Object.prototype.hasOwnProperty.call(map, String(v.id)) ? map[String(v.id)] : (map.d || '');
    var row = wrap.querySelector('[data-dss-badges-row]');
    if (!row || row.innerHTML === html) return;
    hide();
    setRows(section, wrap, html);
  }, true);

  /* ---- preview (staging) ---- */
  var KEY = 'dss-badges-preview', on = false;
  try {
    var q = new URLSearchParams(location.search).get('badges');
    if (q === 'preview') sessionStorage.setItem(KEY, '1');
    if (q === 'off') sessionStorage.removeItem(KEY);
    on = q === 'preview' || sessionStorage.getItem(KEY) === '1';
  } catch (err) { on = /[?&]badges=preview\b/.test(location.search); }
  if (!on) return;

  function apply(root) {
    (root || document).querySelectorAll('template[data-dss-badges-preview]').forEach(function (t) {
      if (t.hasAttribute('data-done')) return;
      t.setAttribute('data-done', '');
      var html = t.innerHTML.trim();
      var wrap = t.closest('[data-dss-badges]');
      if (wrap) {                                   /* product page / quick view: every row in the section + the overlay */
        wrap.setAttribute('data-dss-badges-previewing', '');
        setRows(wrap.closest('.product-section') || wrap, wrap, html);
        return;
      }
      var host = t.parentNode;                      /* card: replace the real stack (max as the snippet draws) */
      var real = host.querySelector(':scope > .dss-badges-card');
      if (real) real.remove();
      if (!html) return;
      var div = document.createElement('div');
      div.className = 'dss-badges-card dss-badges-card--' + (t.getAttribute('data-placement') || 'image');
      div.style.setProperty('--dss-bsize', t.getAttribute('data-size') || '44');
      div.setAttribute('aria-hidden', 'true');
      div.innerHTML = html;
      var max = parseInt(t.getAttribute('data-max') || '1', 10);
      var all = div.querySelectorAll(SEL);
      for (var i = max; i < all.length; i++) all[i].remove();
      host.insertBefore(div, t);
    });
  }
  function start() {
    apply(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { apply(document); break; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ============================================================
   VARIANT MESSAGE POPUP (22 Oct 2026, Sam) — variant metafield
   custom.add_to_basket_message (rich text, set in the admin). After ANY
   successful /cart/add — the product form, quick add, quick view, the
   sticky bar, apps — the theme asks sections/custom-variant-message
   (Section Rendering API, one small GET, cached per variant for the page)
   for that variant's message and shows it in a theme modal ABOVE the cart
   drawer. No message = nothing shown. Both fetch and XMLHttpRequest adds
   are seen, so no add path is missed; a 422 (sold out) is ignored.
   Several messages from one add (items[]) queue and show one after another.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__dssVmsg) return;
  window.__dssVmsg = true;

  var cache = {};              /* variant id -> {html, product, variant} or null (no message) */
  var queue = [], modal = null, inst = null, open = false, opening = false;

  function isAdd(url) { return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url); }
  function items(json) {
    if (!json || typeof json !== 'object') return [];
    if (Array.isArray(json.items)) return json.items;
    return json.variant_id ? [json] : [];
  }
  function onAdded(json) {
    items(json).forEach(function (it) { if (it.handle && it.variant_id) lookup(it.handle, it.variant_id); });
  }
  function lookup(handle, vid) {
    if (Object.prototype.hasOwnProperty.call(cache, vid)) { if (cache[vid]) enqueue(cache[vid]); return; }
    cache[vid] = null;         /* in flight: a double-click adds once more but asks once */
    var url = '/products/' + encodeURIComponent(handle) + '?variant=' + encodeURIComponent(vid) + '&section_id=custom-variant-message';
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var box = document.createElement('div'); box.innerHTML = html;
        var el = box.querySelector('[data-dss-vmsg]');
        if (!el || el.hasAttribute('data-empty') || !el.innerHTML.trim()) return;
        cache[vid] = { html: el.innerHTML, product: el.getAttribute('data-product-title') || '', variant: el.getAttribute('data-variant-title') || '' };
        enqueue(cache[vid]);
      })
      .catch(function () {});
  }

  function ensureModal() {
    if (modal) return true;
    if (!window.theme || !theme.Modals) return false;
    modal = document.createElement('div');
    modal.id = 'DssVariantMessageModal';
    modal.className = 'modal modal--square dss-vmsg';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'DssVmsgTitle');
    modal.innerHTML =
      '<div class="modal__inner"><div class="modal__centered"><div class="modal__centered-content dss-vmsg__box">' +
        '<p class="dss-vmsg__eyebrow">Added to your basket</p>' +
        '<h3 id="DssVmsgTitle" class="dss-vmsg__title"></h3>' +
        '<div class="dss-vmsg__body rte"></div>' +
        '<div class="dss-vmsg__actions"><button type="button" id="DssVmsgOk" class="btn js-modal-close">Got it</button></div>' +
      '</div>' +
      '<button type="button" class="modal__close js-modal-close text-link">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>' +
        '<span class="icon__fallback-text">Close</span>' +
      '</button></div></div>';
    document.body.appendChild(modal);
    inst = new theme.Modals('DssVariantMessageModal', 'dss-vmsg', { focusIdOnOpen: 'DssVmsgOk' });
    /* The theme closes every drawer on the generic modalOpen event, so the cart drawer the add had just
       opened slid shut again under this popup (Sam, 22 Oct). A capture listener on the same target runs
       before the theme's bubble-phase one; while THIS modal is opening it stops the event there, so the
       drawer stays open beneath the overlay and is simply there when the popup closes. Other modals are
       untouched (the flag is only up for the synchronous dispatch inside inst.open()). */
    document.addEventListener('modalOpen', function (evt) { if (opening) evt.stopImmediatePropagation(); }, true);
    /* The drawer also closes on ANY window click and on Escape keyup. Clicks inside the popup (Got it, ×, the
       overlay) must not reach the window, and Escape is handled here so the keyup never does either; the
       theme's own click-outside handler sits on the modal element itself, so it still runs. */
    modal.addEventListener('click', function (evt) { evt.stopPropagation(); });
    modal.addEventListener('keyup', function (evt) { if (evt.key === 'Escape' || evt.keyCode === 27) { evt.stopPropagation(); inst.close(); } });
    document.addEventListener('modalClose.DssVariantMessageModal', function () {
      open = false;
      if (queue.length) { setTimeout(show, 550); return; }          /* after the theme's closing animation */
      /* belt and braces: if the cart drawer is not open once the popup has gone, bring it back via the theme's own hook */
      if (window.theme && theme.settings && theme.settings.cartType === 'drawer') {
        setTimeout(function () {
          if (!document.documentElement.classList.contains('js-drawer-open')) document.dispatchEvent(new CustomEvent('cart:open'));
        }, 550);
      }
    });
    return true;
  }
  function enqueue(msg) { queue.push(msg); show(); }
  function show() {
    if (open || !queue.length || !ensureModal()) return;
    var msg = queue.shift();
    modal.querySelector('.dss-vmsg__title').textContent = msg.product + (msg.variant ? ' — ' + msg.variant : '');
    modal.querySelector('.dss-vmsg__body').innerHTML = msg.html;
    open = true;
    /* the cart drawer opens on ajaxProduct:added and the theme closes any modal on drawerOpen — let that settle first */
    setTimeout(function () { opening = true; try { inst.open(); } finally { opening = false; } }, 150);
  }

  /* see every add: fetch (the theme) and XHR (jQuery-era apps) */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (isAdd(url)) p.then(function (res) { if (res && res.ok) res.clone().json().then(onAdded).catch(function () {}); }).catch(function () {});
      return p;
    };
  }
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this.__dssAdd = isAdd(String(url)); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__dssAdd) this.addEventListener('load', function () {
      if (this.status < 200 || this.status >= 300) return;
      try { onAdded(JSON.parse(this.responseText)); } catch (e) {}
    });
    return xSend.apply(this, arguments);
  };
})();
